<template>
  <div>
    <!-- <loading 
     :active.sync="loadingApplication" 
        :is-full-page="true"
        color="green"
    ></loading>-->
    <v-toolbar class="mt-2" flat color="white" v-if="applicationInfo">
        <v-flex xs3>
          <v-chip color="green" class="white--text" v-if="applicationInfo.isResolved && applicationInfo.isApproved"
            >Approved</v-chip
          >
          <v-chip color="red" class="white--text" v-else-if="applicationInfo.isResolved && applicationInfo.isDenied"
            >Denied</v-chip
          >
          <v-chip color="light-blue" class="white--text" v-else>Pending</v-chip>
        </v-flex>
        <v-flex xs9>
          <h3 class="dark-grey--text px-2">
            <v-layout>
              <span class="grey--text font-weight-light"> Order ID: {{ applicationInfo.id }}</span>
            </v-layout>
          </h3>
        </v-flex>

      <v-spacer></v-spacer>
      <v-btn
        @click="approveApplication"
        v-if="
          (applicationInfo && !applicationInfo.packagesIspId && applicationInfo.isContactVerified) ||
            (applicationInfo.ispVerified &&
              applicationInfo.ispAccepted &&
              !applicationInfo.isResolved &&
              applicationInfo.isInstallVerified &&
              applicationInfo.isDeviceVerified &&
              applicationInfo.locationId &&
              applicationInfo.isContactVerified &&
              (applicationInfo.packagesIspId == null ||
                applicationInfo.supplierOrganisationId != applicationInfo.packagesIsp.customerOrganisationId))
        "
        round
        color="primary"
        >Approve</v-btn
      >
      <v-btn
        round
        disabled
        v-else-if="
          applicationInfo &&
            ((applicationInfo.ispVerified && applicationInfo.ispAccepted) || !applicationInfo.ispVerified) &&
            applicationInfo.serviceAccountId !== null &&
            applicationInfo.packagesIspId !== null &&
            !applicationInfo.isResolved &&
            (!applicationInfo.isInstallVerified ||
              !applicationInfo.isDeviceVerified ||
              !applicationInfo.isContactVerified) &&
            (applicationInfo.packagesIspId == null ||
              applicationInfo.supplierOrganisationId != applicationInfo.packagesIsp.customerOrganisationId)
        "
        class="white--text primary"
        >Approve</v-btn
      >
      <v-btn
        round
        v-else-if="
          applicationInfo &&
            ((applicationInfo.ispVerified && applicationInfo.ispAccepted) || !applicationInfo.ispVerified) &&
            !applicationInfo.isResolved &&
            (applicationInfo.packagesIsp &&
              applicationInfo.supplierOrganisationId != applicationInfo.packagesIsp.customerOrganisationId)
        "
        disabled
        >Approve</v-btn
      >
      <v-btn
        round
        class="white--text"
        color="primary"
        v-else-if="
          applicationInfo &&
            !applicationInfo.isResolved &&
            applicationInfo.isInstallVerified &&
            applicationInfo.locationId &&
            applicationInfo.isDeviceVerified &&
            applicationInfo.isContactVerified &&
            applicationInfo.packagesIsp &&
            applicationInfo.supplierOrganisationId == applicationInfo.packagesIsp.customerOrganisationId &&
            applicationInfo.packagesIsp.datatillProductId &&
            datatillIntegration
        "
        @click="addCustomerModal = true"
        >Approve</v-btn
      >
      <v-btn
        round
        class="white--text"
        color="primary"
        v-else-if="
          applicationInfo &&
            !applicationInfo.isResolved &&
            applicationInfo.isInstallVerified &&
            applicationInfo.isDeviceVerified &&
            applicationInfo.isContactVerified &&
            applicationInfo.packagesIsp &&
            applicationInfo.supplierOrganisationId == applicationInfo.packagesIsp.customerOrganisationId
        "
        @click="ispVerifyModal()"
        >Approve</v-btn
      >
      <v-btn round disabled v-else-if="applicationInfo && !applicationInfo.isResolved">Approve</v-btn>
      <v-btn
        v-if="applicationInfo && !applicationInfo.isResolved"
        round
        color="red"
        class="white--text"
        @click="checkDenyPermissions()"
        >Reject</v-btn
      >
      <h4
        class="grey--text"
        v-if="applicationInfo.ispVerified && applicationInfo.ispAccepted && applicationInfo.ispVerifiedById != null"
      >
        Approved By ISP: {{ applicationInfo.ispVerifiedBy.name }} {{ applicationInfo.ispVerifiedBy.surname }} <br />
        <span>{{ formatDate(applicationInfo.ispVerifiedDate) }}</span>
      </h4>
      <h4
        class="grey--text"
        v-else-if="
          applicationInfo.ispVerified && !applicationInfo.ispAccepted && applicationInfo.ispVerifiedById != null
        "
      >
        Rejected By ISP: {{ applicationInfo.ispVerifiedBy.name }} {{ applicationInfo.ispVerifiedBy.surname }} <br />
        <span>{{ formatDate(applicationInfo.ispVerifiedDate) }}</span>
      </h4>
      <!-- </v-layout> -->
    </v-toolbar>
    <v-divider></v-divider>
    
    <v-stepper v-model="stepperModel" class="elevation-0" alt-labels>
      <v-stepper-header>
        <v-stepper-step step="1" complete color="light-green">
          Order Received
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step color="light-green" step="2" :complete="applicationInfo.isContactVerified">
          Contact(s) Verified
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          color="light-green"
          :complete="applicationInfo.isInstallVerified && applicationInfo.isDeviceVerified"
          step="3"
        >
          Installation Verified
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4" color="light-green" :complete="applicationInfo.ispAccepted">
          ISP Approved
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          step="5"
          color="light-green"
          :complete="applicationInfo.isResolved && applicationInfo.isApproved"
          :rules="[
            () => {
              if (applicationInfo.isResolved && applicationInfo.isDenied) {
                return false;
              } else {
                return true;
              }
            },
          ]"
        >
          FNO Approved
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="6" color="light-green" :complete="applicationInfo.isResolved" style="cursor: pointer">
          <span
            @click="
              applicationInfo.serviceAccountId ? redirectToServiceAccount(applicationInfo.serviceAccountId) : null
            "
            >{{ applicationInfo.serviceAccount ? applicationInfo.serviceAccount.circuitNumber : "Complete" }}</span
          >
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <v-card flat>
      <v-snackbar :top="y === 'top'" v-model="snackbar">
        {{ text }}
        <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
      <v-container fluid grid-list-xs fill-height>
        <v-layout align-space-between justify-space-around row fill-height wrap>
          <v-flex grow mb-1>
            <v-card class="rounded-card" min-width="500px">
              <v-card-text>
                <v-list>
                   <v-list-tile>
        <v-list-tile-action>
          <v-icon  v-if="applicationInfo.location">location_on</v-icon>
          <v-icon color="warning" v-else>warning</v-icon>
          </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-if="applicationInfo.location">
            {{ applicationInfo.location.locationDescription }}
          </v-list-tile-title>
          <v-list-tile-title v-else>
            {{ formattedAddress }}
          </v-list-tile-title>
          <v-list-tile-subtitle>
              <span class="grey--text font-weight-light" v-if="applicationInfo.locationId">{{
                applicationInfo.location.locationNetwork.name
              }}</span>
              <span class="grey--text font-weight-light" v-else-if="applicationInfo.locationNetwork">{{
                applicationInfo.locationNetwork.name
              }}</span>
          </v-list-tile-subtitle>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-layout justify-center >
<v-icon v-if="applicationInfo.locationId" small @click="goToLocation()"
                >launch</v-icon
              >
              <v-icon small v-if="!applicationInfo.location" @click="attachLocationModal=true"
                >edit</v-icon
              >
          </v-layout>
          
        </v-list-tile-action>
      </v-list-tile>    
                </v-list>
                <h3 class="dark-grey--text">
                  Request Summary
                  <v-chip
                    v-if="
                      applicationInfo.packagesIspId != null &&
                        applicationInfo.ispVerified &&
                        applicationInfo.ispAccepted
                    "
                    class="white--text"
                    color="success"
                    >ISP Accepted</v-chip
                  >
                  <v-chip
                    v-else-if="
                      applicationInfo.packagesIspId != null &&
                        applicationInfo.ispVerified &&
                        !applicationInfo.ispAccepted
                    "
                    class="white--text"
                    color="red"
                    >ISP Rejected</v-chip
                  >
                  <v-chip
                    v-else-if="applicationInfo.packagesIspId != null && !applicationInfo.ispVerified"
                    class="white--text"
                    color="warning"
                    >Pending ISP Verification</v-chip
                  >
                </h3>
                <!-- <v-btn @click="findSimilarContacts('Mark')">Similar Xero Contacts</v-btn> -->
                <v-container grid-list-xs>
                  <v-layout wrap>
                 
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-left>
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            Date Submitted:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{ formatDate(applicationInfo.createdAt) }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs6 v-if="applicationInfo.activationDate">
                          <h3 class="subheading grey--text font-weight-bold">
                            Preferred Activation Date:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.activationDate }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <!-- <v-layout justify-center>
                        <v-flex xs8>
                          <h3 class="subheading grey--text font-weight-bold">
                            TV over Fibre:
                          </h3>
                        </v-flex>
                        <v-flex xs4>
                          <v-icon
                            color="green"
                            v-if="applicationInfo.hasTvOverFibre"
                            >done</v-icon
                          >
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                      </v-layout> -->
                      <!-- <v-layout
                        justify-center
                        v-if="applicationInfo.hasTvOverFibre"
                      >
                        <v-flex xs8>
                          <h3 class="subheading grey--text font-weight-bold">
                            GTU Installation Fee:
                          </h3>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.gtuInstallationFee | currency }}
                          </h3>
                        </v-flex>
                      </v-layout> -->
                      <v-layout justify-center v-if="applicationInfo.packagesIspId !== null">
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            Router Installation Fee:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.routerInstallationFee | currency }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        justify-center
                        v-if="
                          applicationInfo.packagesIspId !== null &&
                            applicationInfo.locationNetwork &&
                            applicationInfo.locationNetwork.activationFeeAmount &&
                            applicationInfo.locationNetwork.activationFeeAmount != 0
                        "
                      >
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            Data Activation Fee:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.locationNetwork.activationFeeAmount | currency }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        justify-center
                        v-if="
                          applicationInfo &&
                            applicationInfo.packagesIspId !== null &&
                            applicationInfo.packagesIsp &&
                            applicationInfo.packagesIsp.packagesFno &&
                            applicationInfo.packagesIsp.packagesFno.setupFee != 0
                        "
                      >
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            FNO Package Setup Fee:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.packagesIsp.packagesFno.setupFee | currency }}
                          </h3>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center>
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            Data Package:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                            v-if="applicationInfo.packagesIspId !== null && applicationInfo.packagesIsp"
                          >
                            {{ applicationInfo.packagesIsp.customerOrganisation.name }}
                            | {{ applicationInfo.packagesIsp.name }}
                          </h3>
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        justify-center
                        v-if="applicationInfo.packagesIspId !== null && applicationInfo.packagesIsp"
                      >
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            Data Package Term:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.packagesIsp.term }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        justify-center
                        v-if="applicationInfo.packagesIspId !== null && applicationInfo.packagesIsp"
                      >
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            Data Package Monthly Payment:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.ispRecurringPriceVatInc | currency }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="applicationInfo.packagesIspId !== null && applicationInfo.packagesIsp">
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            Data Package Once-Off:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.ispOnceOffPriceVatInc | currency }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="applicationInfo.isValidPromo !== null">
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            Promotion Code:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <v-layout>
                            <h3
                              v-if="applicationInfo && applicationInfo.promotion"
                              class="grey--text font-weight-light"
                            >
                              {{ applicationInfo.promotion.name }}
                            </h3>
                            <h3
                              v-else-if="applicationInfo && applicationInfo.promoCode"
                              class="grey--text font-weight-light"
                            >
                              {{ applicationInfo.promoCode }}
                            </h3>

                            <v-chip
                              small
                              v-if="applicationInfo.isValidPromo == true"
                              class="white--text"
                              color="light-green"
                              >Valid</v-chip
                            >
                            <v-chip small v-else class="white--text" color="orange">Invalid</v-chip>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="products.length > 0">
                         <v-flex xs6 mx-1>
                    <h3 class="grey--text">Additional Products:</h3>
                  </v-flex>
                  <v-flex xs4 mx-1 >
                    <v-chip
                      style="cursor: pointer"
                      class="white--text"
                      color="primary"
                      @click="showProducts = true"
                      >{{ products.length }}</v-chip
                    >
                  </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs6>
                          <h3 class="subheading grey--text font-weight-bold">
                            Notes:
                          </h3>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light" style="word-wrap: break-word">
                            {{ applicationInfo.notes }}
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
            <!-- <v-card-text v-if="(applicationInfo.routerInstallationFee>0)||(applicationInfo.hasTvOverFibre&&applicationInfo.gtuInstallationFee>0)">
            <h3 class="dark-grey--text">Billing <v-btn v-if="!applicationInfo.isInvoiced" round class="primary" @click="generateXeroInvoice()">Create Xero Invoice</v-btn></h3>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12  text-xs-left>
            <v-layout justify-center>
                        <v-flex xs8>
                            <h3 class="subheading grey--text font-weight-bold"> Installation Fees Invoiced:</h3>
                        </v-flex>
                        <v-flex xs4>
                        <h3 class="grey--text font-weight-light" v-if="applicationInfo.isInvoiced"><v-icon color="light-green">check</v-icon><span class="grey--text font-weight-light" v-if="applicationInfo.invoiceNumber!==''">
                           | Invoice No: {{applicationInfo.invoiceNumber}}</span></h3>
                        <h3 class="grey--text font-weight-light" v-else><v-icon color="red">not_interested</v-icon></h3>
                        </v-flex>
                    </v-layout>
                    </v-flex>
              </v-layout>
              <v-layout wrap>
              <v-flex xs12 sm12 md12  text-xs-left>
              <v-layout justify-center v-if="applicationInfo.isInvoiced">
                        <v-flex xs8>
                            <h3 class="subheading grey--text font-weight-bold"> Invoice Paid:</h3>
                        </v-flex>
                        <v-flex xs4>
                        <h3 class="grey--text font-weight-light" v-if="applicationInfo.isPaid"><v-icon color="light-green">check</v-icon></h3>
                        <h3 class="grey--text font-weight-light" v-else><v-icon color="red">not_interested</v-icon></h3>
                        </v-flex>
                    </v-layout>
                    </v-flex>
              </v-layout>
            </v-container>
            </v-card-text>-->
          </v-flex>
          <v-flex shrink mb-1 v-show="false">
            <v-card class="rounded-card">
              <v-card-text>
                <h3 class="dark-grey--text font-weight-bold">Accounts</h3>
                <v-layout
                  mt-2
                  align-center
                  justify-left
                  wrap
                  class="text-xs-left"
                  v-if="$store.state.currentOrg.org.accountingSystem == 'SageOne' && ageAnalysis"
                >
                  <v-flex xs6 mx-1 v-if="products.length > 0">
                    <h3 class="grey--text">Additional Products:</h3>
                  </v-flex>
                  <v-flex xs4 mx-1 v-if="products.length > 0">
                    <v-chip
                      style="cursor: pointer"
                      class="white--text"
                      color="primary"
                      @click="showProducts = true"
                      small
                      >{{ products.length }}</v-chip
                    >
                  </v-flex>
                  <!-- <v-flex xs12 v-if="ageAnalysis">
                          <h3 class="text-xs-center">Age Analysis</h3>
                        </v-flex> -->
                  <v-flex xs12 v-if="ageAnalysis" class="grey--text text-xs-center">
                    <v-layout justify-center align-center wrap>
                      <v-flex xs3><b>120 +</b></v-flex>
                      <v-flex xs3><b>90</b></v-flex>
                      <v-flex xs3><b>60</b></v-flex>
                      <v-flex xs3><b>30</b></v-flex>
                    </v-layout>
                    <v-layout justify-center align-center wrap>
                      <v-flex xs3
                        ><span>{{ ageAnalysis.Days120Plus | currency }}</span></v-flex
                      >
                      <v-flex xs3
                        ><span>{{ ageAnalysis.Days90 | currency }}</span></v-flex
                      >
                      <v-flex xs3
                        ><span>{{ ageAnalysis.Days60 | currency }}</span></v-flex
                      >
                      <v-flex xs3
                        ><span>{{ ageAnalysis.Days30 | currency }}</span></v-flex
                      >
                      <!-- <v-flex xs2><span>{{ageAnalysis.Current|currency}}</span></v-flex> -->
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 mx-1 v-if="ageAnalysis">
                    <h3 class="grey--text">Current Balance:</h3>
                  </v-flex>
                  <v-flex xs4 mx-1 v-if="ageAnalysis">
                    <v-chip color="blue" class="white--text">{{ ageAnalysis.Current | currency }}</v-chip>
                  </v-flex>
                </v-layout>
                <div
                  v-if="
                    applicationInfo.packagesIsp &&
                      applicationInfo.packagesIsp.customerOrganisationId == $store.state.currentOrg.org.id
                  "
                >
                  <h3 class="dark-grey--text font-weight-bold">
                    Data Package Billing
                  </h3>
                  <v-layout align-center justify-left wrap class="text-xs-left">
                    <v-flex xs6 mx-1>
                      <h4 class="grey--text">Debit Order Mandate</h4>
                    </v-flex>
                    <v-flex xs4 mx-1>
                      <v-btn
                        round
                        @click="
                          !applicationInfo.debitOrderStatus || applicationInfo.debitOrderStatus == 'Unsent'
                            ? sendDebitOrder()
                            : null
                        "
                        small
                        color="red"
                        class="white--text"
                        v-if="
                          applicationInfo.debitOrderStatus != 'Sent' && applicationInfo.debitOrderStatus != 'Signed'
                        "
                      >
                        Unsent
                      </v-btn>
                      <v-chip small v-else color="light-green" class="white--text">{{
                        applicationInfo.debitOrderStatus
                      }}</v-chip>
                      <h4 class="grey--text font-weight-light"></h4>
                    </v-flex>
                    <v-flex xs6 mx-1 v-if="$store.state.currentOrg.org.accountingSystem == 'SageOne'">
                      <h4 class="grey--text">Recurring Invoice</h4>
                    </v-flex>
                    <v-flex xs4 mx-1 v-if="applicationInfo.recurringInvoiceNumber">
                      <h4 class="grey--text font-weight-light">
                        {{ applicationInfo.recurringInvoiceNumber }}
                      </h4>
                    </v-flex>
                    <v-flex xs4 mx-1 v-else-if="$store.state.currentOrg.org.accountingSystem == 'SageOne'">
                      <v-btn
                        small
                        round
                        color="primary"
                        class="white--text"
                        v-if="$store.state.currentOrg.org.accountingSystem == 'Xero'"
                        >Create</v-btn
                      >
                      <v-btn
                        small
                        round
                        color="primary"
                        class="white--text"
                        v-else-if="$store.state.currentOrg.org.accountingSystem == 'SageOne'"
                        @click="createSageRecurringInvoice()"
                        >Create</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex grow mb-1 style="min-width: 250px">
            <v-layout>
              <v-flex xs12 mx-1>
                <v-card class="rounded-card">
                  <v-card-text>
                    <h3 class="dark-grey--text font-weight-bold">
                      <v-icon v-if="!applicationInfo.isResolved && !applicationInfo.isContactVerified" color="orange"
                        >warning</v-icon
                      >Contact Information
                      <v-btn
                        v-if="
                          !verifyingContact &&
                            !applicationInfo.isResolved &&
                            !applicationInfo.isContactVerified &&
                            applicationInfo.primaryContactId !== null
                        "
                        @click="verifyContact"
                        round
                        color="primary"
                        >Verify
                      </v-btn>
                      <v-btn v-if="verifyingContact" round disabled>
                        <span>Verifying </span>
                        <v-progress-circular size="20" indeterminate color="white"></v-progress-circular
                      ></v-btn>
                      <v-btn v-if="applicationInfo.isContactVerified" round color="primary" disabled>
                        <v-icon color="primary">check</v-icon>Verified
                      </v-btn>
                    </h3>
                    <!-- <v-toolbar
                      flat
                      color="white"
                      v-if="locationContacts.length > 0"
                    >
                      <v-tabs div="tabs" grow>
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab
                          @click="
                            showApplicationContacts = true;
                            showLocationContacts = false;
                          "
                          >Order Contacts</v-tab
                        >
                        <v-tab
                          @click="
                            showApplicationContacts = false;
                            showLocationContacts = true;
                          "
                          >Existing Location Contacts</v-tab
                        >
                      </v-tabs>
                    </v-toolbar> -->
                    <v-container v-if="showLocationContacts" style="width:100%; padding:0; margin:0">
                        <!-- <v-flex
                      xs12
                      sm6
                      md6
                      lg6
                      v-for="(person, index) in locationContacts"
                      :key="person.contact.name"
                    > -->
                        <v-layout wrap align-center>
                          <v-flex xs1>
                            <v-icon @click="index--" v-if="index > 0">keyboard_arrow_left</v-icon>
                          </v-flex>
                          <v-flex xs12>
                            <v-card hover class="text-xs-center mb-2 mx-0 my-0">
                              <div class="primary subheading text-uppercase white--text">
                                {{ locationContacts[index].contactType.name }}
                              </div>
                              <v-responsive></v-responsive>
                              <v-card-text>
                                <div class="subheading">
                                  {{ locationContacts[index].contact.name }}
                                  {{ locationContacts[index].contact.surname }}
                                </div>
                                <v-layout>
                                  <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">smartphone</v-icon>
                                  </v-flex>
                                  <v-flex xs8 justify-left>
                                    <div
                                      class="grey--text"
                                      style="
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                      "
                                    >
                                      {{ locationContacts[index].contact.mobileNumber }}
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <v-layout>
                                  <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">email</v-icon>
                                  </v-flex>
                                  <v-flex xs8 justify-left>
                                    <div
                                      class="grey--text"
                                      style="
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                      "
                                    >
                                      {{ locationContacts[index].contact.emailAddress }}
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <v-layout>
                                  <v-flex xs2 class="text-xs-right">
                                    <v-icon small color="grey">perm_identity</v-icon>
                                  </v-flex>
                                  <v-flex xs8 justify-left>
                                    <div
                                      class="grey--text"
                                      style="
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                      "
                                    >
                                      {{ locationContacts[index].contact.idNumber }}
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                              <v-card-actions class="justify-center layout px-0" v-if="!applicationInfo.isResolved">
                                <v-btn flat color="red" @click="removeContact(locationContacts[index])">
                                  <v-icon small>delete</v-icon>Remove
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-flex>
                          <v-flex xs1>
                            <v-icon @click="index++" v-if="index < locationContacts.length - 1"
                              >keyboard_arrow_right</v-icon
                            >
                          </v-flex>
                      </v-layout>
                    </v-container>
                    <v-container v-if="showApplicationContacts">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-layout align-center  v-if="applicationContactIndex === 0">
                            <v-flex xs1>
                              <v-icon @click="applicationContactIndex--" v-if="applicationContactIndex > 0"
                                >keyboard_arrow_left</v-icon
                              >
                            </v-flex>
                            <v-flex xs10>
                              <v-card hover class="text-xs-center" style="padding:0;margin:0">
                                <div class="primary subheading text-uppercase white--text">
                                  Primary
                                </div>
                                <v-card-text style="padding:0;margin:0">
                                  <div class="subheading" v-if="applicationInfo.primaryContactTitle !== null">
                                    {{ applicationInfo.primaryContactTitle }}
                                    {{ applicationInfo.primaryContactFirstname }}
                                    {{ applicationInfo.primaryContactLastname }}
                                  </div>
                                  <div class="subheading" v-else>
                                    {{ applicationInfo.primaryContactFirstname }}
                                    {{ applicationInfo.primaryContactLastname }}
                                  </div>
                                  <v-layout>
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">smartphone</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div
                                        class="grey--text"
                                        style="
                                          text-overflow: ellipsis;
                                          overflow: hidden;
                                        "
                                      >
                                        {{ applicationInfo.primaryContactMobileNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">email</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div
                                        class="grey--text"
                                        style="
                                          text-overflow: ellipsis;
                                          overflow: hidden;
                                        "
                                      >
                                        {{ applicationInfo.primaryContactEmailAddress }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">perm_identity</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div
                                        class="grey--text"
                                        style="
                                          text-overflow: ellipsis;
                                          overflow: hidden;
                                        "
                                      >
                                        {{ applicationInfo.primaryContactIdNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                                <v-card-actions class="justify-center layout px-0" v-if="!applicationInfo.isResolved">
                                  <v-layout justify-center wrap>
                                    <v-btn
                                    icon
                                      class="ma-1"
                                      v-if="applicationInfo.primaryContactId === null"
                                      round
                                      color="primary"
                                      @click="editContact('Primary')"
                                    >
                                      <v-icon small>edit</v-icon>
                                    </v-btn>
                                    <v-btn
                                      class="ma-1"
                                      v-if="
                                        !creatingPrimaryContact &&
                                          applicationInfo.primaryContactId === null &&
                                          !linkedPrimaryContacts.length > 0
                                      "
                                      round
                                      color="primary"
                                      @click="addContact('Primary')"
                                    >
                                      <v-icon small>person_add</v-icon>
                                    </v-btn>
                                    <v-btn v-if="creatingPrimaryContact" round disabled>
                                      <span>Adding Contact </span>
                                      <v-progress-circular size="20" indeterminate color="white"></v-progress-circular
                                    ></v-btn>
                                    <v-btn
                                      v-if="
                                        applicationInfo.primaryContactId === null && linkedPrimaryContacts.length > 0
                                      "
                                      icon
                                      class="white--text ma-1"
                                      round
                                      color="orange"
                                      @click="similarContactsModalPrimary = true"
                                    >
                                      <v-icon color="white">priority_high</v-icon>
                                    </v-btn>
                                    <!-- <v-btn
                                      class="ma-1"
                                      round
                                      disabled
                                      v-else-if="
                                        applicationInfo.primaryContactId !==
                                        null
                                      "
                                    >
                                      <v-icon small>check</v-icon>Added
                                    </v-btn> -->
                                  </v-layout>
                                </v-card-actions>
                              </v-card>
                            </v-flex>
                            <v-flex xs2>
                              <v-icon
                                @click="applicationContactIndex++"
                                v-if="
                                  applicationInfo.secondaryContactFirstname !== null ||
                                    applicationInfo.billingContactFirstname !== null
                                "
                                >keyboard_arrow_right</v-icon
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          lg12
                          v-if="applicationContactIndex === 1 && applicationInfo.secondaryContactFirstname !== null"
                        >
                          <v-layout align-center>
                            <v-flex xs1>
                              <v-icon @click="applicationContactIndex--" v-if="applicationContactIndex > 0"
                                >keyboard_arrow_left</v-icon
                              >
                            </v-flex>
                            <v-flex xs10>
                              <v-card hover class="text-xs-center mb-2 mx-1">
                                <div class="primary subheading text-uppercase white--text">
                                  Secondary
                                </div>
                                <v-responsive></v-responsive>
                                <v-card-text>
                                  <div class="subheading" v-if="applicationInfo.secondaryContactTitle !== null">
                                    {{ applicationInfo.secondaryContactTitle }}
                                    {{ applicationInfo.secondaryContactFirstname }}
                                    {{ applicationInfo.secondaryContactLastname }}
                                  </div>
                                  <div class="subheading" v-else>
                                    {{ applicationInfo.secondaryContactFirstname }}
                                    {{ applicationInfo.secondaryContactLastname }}
                                  </div>
                                  <v-layout v-if="applicationInfo.secondaryContactMobileNumber !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">smartphone</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div
                                        class="grey--text"
                                        style="
                                          text-overflow: ellipsis;
                                          overflow: hidden;
                                        "
                                      >
                                        {{ applicationInfo.secondaryContactMobileNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout v-if="applicationInfo.secondaryContactEmailAddress !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">email</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div
                                        class="grey--text"
                                        style="
                                          text-overflow: ellipsis;
                                          overflow: hidden;
                                        "
                                      >
                                        {{ applicationInfo.secondaryContactEmailAddress }}
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout v-if="applicationInfo.secondaryContactIdNumber !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">perm_identity</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div
                                        class="grey--text"
                                        style="
                                          text-overflow: ellipsis;
                                          overflow: hidden;
                                        "
                                      >
                                        {{ applicationInfo.secondaryContactIdNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                                <v-card-actions class="justify-center layout px-0" v-if="!applicationInfo.isResolved">
                                  <v-layout row wrap justify-center>
                                    <v-btn
                                      v-if="applicationInfo.primaryContactId === null"
                                      round
                                      icon
                                      color="primary"
                                      @click="editContact('Secondary')"
                                    >
                                      <v-icon small>edit</v-icon>
                                    </v-btn>
                                    <v-btn
                                      v-if="
                                        !creatingSecondaryContact &&
                                          applicationInfo.secondaryContactId === null &&
                                          !linkedSecondaryContacts.length > 0
                                      "
                                      round
                                      icon
                                      color="primary"
                                      @click="addContact('Secondary')"
                                    >
                                      <v-icon small>person_add</v-icon>
                                    </v-btn>
                                    <v-btn v-if="creatingSecondaryContact" round disabled>
                                      <!-- <span> </span> -->
                                      <v-progress-circular size="20" indeterminate color="white"></v-progress-circular
                                    ></v-btn>
                                    <v-btn
                                      v-if="
                                        applicationInfo.secondaryContactId === null &&
                                          linkedSecondaryContacts.length > 0
                                      "
                                      class="white--text"
                                      round
                                      color="orange"
                                      @click="similarContactsModalSecondary = true"
                                      icon
                                    >
                                      <v-icon color="white">priority_high</v-icon>
                                    </v-btn>
                                    <v-btn round disabled v-else-if="applicationInfo.secondaryContactId !== null">
                                      <v-icon small>check</v-icon>
                                    </v-btn>
                                  </v-layout>
                                </v-card-actions>
                              </v-card>
                            </v-flex>
                            <v-flex xs1>
                              <v-icon
                                @click="applicationContactIndex++"
                                v-if="applicationInfo.billingContactFirstname !== null"
                                >keyboard_arrow_right</v-icon
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          lg12
                          v-if="
                            (applicationContactIndex === 1 &&
                              applicationInfo.secondaryContactFirstname === null &&
                              applicationInfo.billingContactFirstname !== null) ||
                              (applicationContactIndex === 2 &&
                                applicationInfo.secondaryContactFirstname !== null &&
                                applicationInfo.billingContactFirstname !== null)
                          "
                        >
                          <v-layout align-center>
                            <v-flex xs1>
                              <v-icon @click="applicationContactIndex--" v-if="applicationContactIndex > 0"
                                >keyboard_arrow_left</v-icon
                              >
                            </v-flex>
                            <v-flex xs10>
                              <v-card hover class="text-xs-center mb-2 mx-1">
                                <div class="primary subheading text-uppercase white--text">
                                  Billing
                                </div>
                                <v-responsive></v-responsive>
                                <v-card-text>
                                  <div class="subheading" v-if="applicationInfo.billingContactTitle !== null">
                                    {{ applicationInfo.billingContactTitle }}
                                    {{ applicationInfo.billingContactFirstname }}
                                    {{ applicationInfo.billingContactLastname }}
                                  </div>
                                  <div class="subheading" v-else>
                                    {{ applicationInfo.billingContactFirstname }}
                                    {{ applicationInfo.billingContactLastname }}
                                  </div>
                                  <v-layout v-if="applicationInfo.billingContactMobileNumber !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">smartphone</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div
                                        class="grey--text"
                                        style="
                                          text-overflow: ellipsis;
                                          overflow: hidden;
                                        "
                                      >
                                        {{ applicationInfo.billingContactMobileNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout v-if="applicationInfo.billingContactEmailAddress !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">email</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div
                                        class="grey--text"
                                        style="
                                          text-overflow: ellipsis;
                                          overflow: hidden;
                                        "
                                      >
                                        {{ applicationInfo.billingContactEmailAddress }}
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout v-if="applicationInfo.billingContactIdNumber !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">perm_identity</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div
                                        class="grey--text"
                                        style="
                                          text-overflow: ellipsis;
                                          overflow: hidden;
                                        "
                                      >
                                        {{ applicationInfo.billingContactIdNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                                <v-card-actions class="justify-center layout px-0" v-if="!applicationInfo.isResolved">
                                  <v-layout row wrap justify-center>
                                    <v-btn
                                      v-if="applicationInfo.billingContactId === null"
                                      round
                                      icon
                                      color="primary"
                                      @click="editContact('Billing')"
                                    >
                                      <v-icon small>edit</v-icon>
                                    </v-btn>
                                    <v-btn
                                      v-if="
                                        !creatingBillingContact &&
                                          applicationInfo.billingContactId === null &&
                                          !linkedBillingContacts.length > 0
                                      "
                                      round
                                      icon
                                      color="primary"
                                      @click="addContact('Billing')"
                                    >
                                      <v-icon small>person_add</v-icon>
                                    </v-btn>
                                    <v-btn v-if="creatingBillingContact" round disabled>
                                      <!-- <span>Adding Contact </span> -->
                                      <v-progress-circular size="20" indeterminate color="white"></v-progress-circular
                                    ></v-btn>
                                    <v-btn
                                      v-if="
                                        applicationInfo.billingContactId === null && linkedBillingContacts.length > 0
                                      "
                                      class="white--text"
                                      round
                                      color="orange"
                                      @click="similarContactsModalBilling = true"
                                      icon
                                    >
                                      <v-icon color="white">priority_high</v-icon>
                                    </v-btn>
                                    <v-btn round disabled v-else-if="applicationInfo.billingContactId !== null">
                                      <v-icon small>check</v-icon>
                                    </v-btn>
                                  </v-layout>
                                </v-card-actions>
                              </v-card>
                            </v-flex>
                            <v-flex xs2> </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex grow mb-1>
            <v-card elevation="5" class="rounded-card" min-width="300px;" max-width="450px">
              <v-card-text>
                <h3 class="dark-grey--text">
                  Comments
                </h3>
                <h4 class="mt-3 grey--text" style="text-align: left">
                  <v-checkbox
                    class="grey--text font-weight-light"
                    label="Internal Comment"
                    v-model="internal"
                  ></v-checkbox>
                </h4>

                <at-ta :members="members">
                  <v-textarea outline auto-grow rows="2" v-model="comment"></v-textarea>
                </at-ta>
                <v-btn round @click="addApplicationComment(comment)" color="primary">Comment</v-btn>
                <v-layout wrap style="overflow-y: auto; max-height: 250px;" class="mt-2">
                  <v-flex xs12 v-for="item in commentArray" :key="item.id">
                    <v-layout align-center style="border-bottom: 1px solid lightgrey">
                      <v-flex xs2>
                         <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-avatar
                                  v-on="on"
                                  size="30px"
                                  color="primary"
                                  style="width: 30px"
                                  class="mx-1 font-weight-light white--text"
                                  v-if="item !== 'undefined'"
                                  >{{ item.commentedByName.charAt(0) }}{{ item.commentedBySurname.charAt(0) }}</v-avatar
                                >
                              </template>
                              <span class="font-weight-light"
                                >{{ item.commentedByName }} {{ item.commentedBySurname }}</span
                              >
                            </v-tooltip>
                      </v-flex>
                      <v-flex xs10 class="text-xs-left px-1">
                        <span style="fontSize: 14px;">{{item.comment}}</span> <br>
                        <span style="fontSize: 12px;color:grey">{{ formatDateTime(item.createdAt) }}</span>

                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- <v-list style="overflow-y: auto; max-height: 250px;">
                      <v-list-tile  v-for="item in commentArray" :key="item.id">
                        <v-list-tile-avatar>
                          <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-avatar
                                  v-on="on"
                                  size="30px"
                                  color="primary"
                                  style="width: 30px"
                                  class="mx-1 font-weight-light white--text"
                                  v-if="item !== 'undefined'"
                                  >{{ item.commentedByName.charAt(0) }}{{ item.commentedBySurname.charAt(0) }}</v-avatar
                                >
                              </template>
                              <span class="font-weight-light"
                                >{{ item.commentedByName }} {{ item.commentedBySurname }}</span
                              >
                            </v-tooltip>
                        </v-list-tile-avatar>
                        <v-list-tile-content >
                           <v-list-item-subtitle class="text-wrap" v-text="item.comment"></v-list-item-subtitle>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list> -->
                
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex grow mb-1 :key="ticketKey">
            <v-card elevation="5" class="rounded-card" min-width="300px">
              <v-card-text>
                <h3 class="dark-grey--text">
                  Tickets <v-chip>{{ tickets.length }}</v-chip>
                  <v-icon color="primary" @click="createTicket('')">add_circle_outline</v-icon>
                  <v-icon color="primary" @click="fetchTickets()">refresh</v-icon>
                </h3>
                <v-data-table :rows-per-page-items="5" :items="tickets" hide-headers style="cursor: pointer">
                  <template v-slot:items="props">
                    <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                      {{ props.item.id }}
                    </td>

                    <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                      <h3 class="grey--text">
                        <v-chip
                          small
                          :class="`${props.item.currentStatus.replace(/\s/g, '').toLowerCase()} white--text`"
                          >{{ props.item.currentStatus }}</v-chip
                        >
                      </h3>
                    </td>
                    <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                      {{ props.item.ticketCategoryItem.name }}
                    </td>
                    <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                      {{ formatDate(props.item.dueDate) }}
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex shrink mb-1>
            <v-card v-if="applicationInfo && applicationInfo.location" class="rounded-card">
              <v-card-text>
                <h3 class="dark-grey--text font-weight-bold">
                  <v-icon
                    v-if="
                      applicationInfo &&
                        !applicationInfo.isResolved &&
                        (!applicationInfo.isInstallVerified || !applicationInfo.isDeviceVerified)
                    "
                    color="orange"
                    >warning</v-icon
                  >Installation Information
                  <!-- <v-btn v-else disabled round>Verify</v-btn> -->
                  <v-btn
                    v-if="!applicationInfo.location.fibrePulled && !applicationInfo.location.equipmentInstalled"
                    round
                    color="primary"
                    class="white--text"
                    @click="createTicket('Full')"
                    >Create Ticket</v-btn
                  >
                  <v-btn
                    v-else-if="!applicationInfo.location.fibrePulled"
                    round
                    color="primary"
                    class="white--text"
                    @click="createTicket('Passive')"
                    >Create Ticket</v-btn
                  >
                  <v-btn
                    v-else-if="!applicationInfo.location.equipmentInstalled"
                    round
                    color="primary"
                    class="white--text"
                    @click="createTicket('Active')"
                    >Create Ticket</v-btn
                  ><v-btn
                    v-else-if="
                      (applicationInfo && !applicationInfo.isInstallVerified) || !applicationInfo.isDeviceVerified
                    "
                    round
                    color="primary"
                    class="white--text"
                    @click="createTicket('Active')"
                    >Create Ticket</v-btn
                  >

                  <v-btn
                    v-if="
                      !verifyingInstallation &&
                        !verifyingDevice &&
                        applicationInfo &&
                        !applicationInfo.isResolved &&
                        applicationInfo.location.fibrePulled &&
                        applicationInfo.location.equipmentInstalled &&
                        (!applicationInfo.isInstallVerified || !applicationInfo.isDeviceVerified)
                    "
                    round
                    class="white--text primary"
                    @click="
                      verifyDevice();
                      verifyInstallation();
                    "
                    >Verify
                  </v-btn>
                  <v-btn v-if="verifyingInstallation || verifyingDevice" round disabled>
                    <span>Verifying </span>
                    <v-progress-circular size="20" indeterminate color="white"></v-progress-circular
                  ></v-btn>
                  <v-btn
                    v-else-if="applicationInfo && applicationInfo.isInstallVerified && applicationInfo.isDeviceVerified"
                    round
                    disabled
                  >
                    <v-icon color="white">check</v-icon>Verified
                  </v-btn>
                </h3>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center>
                        <v-flex xs8>
                          <h3 class="subheading grey--text font-weight-bold">
                            <v-icon v-if="!applicationInfo.location.fibrePulled" color="red">error_outline</v-icon
                            >Passive Installation Complete:
                          </h3>
                        </v-flex>
                        <v-flex xs4>
                          <v-layout wrap>
                            <v-icon color="green" v-if="applicationInfo.location.fibrePulled">done</v-icon>
                            <v-icon color="red" v-else>not_interested</v-icon>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs8>
                          <h3 class="subheading grey--text font-weight-bold">
                            <v-icon v-if="!applicationInfo.location.equipmentInstalled || !device" color="red"
                              >error_outline</v-icon
                            >Device Installation Complete:
                          </h3>
                        </v-flex>
                        <v-flex xs4>
                          <v-icon color="green" v-if="applicationInfo.location.equipmentInstalled && device"
                            >done</v-icon
                          >
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="this.device !== null">
                        <v-flex xs8>
                          <h3 class="subheading grey--text font-weight-bold">
                            Primary Device:
                          </h3>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="grey--text font-weight-light"
                            style="cursor: pointer"
                            @click="goToDevice(device.id)"
                          >
                            {{ device.deviceMakeModel.deviceMake.name }}
                            {{ device.deviceMakeModel.name }} |
                            {{ device.ponMac }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs8>
                          <h3 class="subheading grey--text font-weight-bold">
                            Secondary Device:
                          </h3>
                        </v-flex>
                        <v-flex xs4 :key="secondaryDeviceKey">
                          <h3
                            class="grey--text font-weight-light"
                            style="cursor: pointer"
                            @click="goToDevice(secondaryDevice.id)"
                            v-if="secondaryDevice"
                          >
                            {{ secondaryDevice.deviceMakeModel.deviceMake.name }}
                            {{ secondaryDevice.deviceMakeModel.name }} |
                            <!-- <span v-if="secondaryDevice.serialNumber"> | {{ secondaryDevice.serialNumber }}</span>
                            <span v-if="secondaryDevice.ponMac"> | {{ secondaryDevice.ponMac }}</span> -->
                          </h3>
                          <v-icon color="primary" v-else @click="addSecondaryDevice()">add_circle_outline</v-icon>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex grow mb-1>
            <documentcomponent
              :key="key"
              :applicationid="this.applicationInfo.id"
              :documents="documents"
              @documentChange="fetchDocuments"
            >
            </documentcomponent>
          </v-flex>

          <!-- <v-flex shrink mb-1 v-if="applicationInfo.serviceAccountId">
            <v-card
              v-if="applicationInfo.serviceAccountId"
              
              class="rounded-card mt-1"
            >
              <v-card-text>
                <h3 class="dark-grey--text font-weight-bold">
                  Associated Service Account
                </h3>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-card
                        hover
                        class="text-xs-center mb-2 mx-2"
                        @click="
                          redirectToServiceAccount(
                            applicationInfo.serviceAccountId
                          )
                        "
                      >
                        <div
                          class="primary subheading text-uppercase white--text"
                        >
                          {{
                            applicationInfo.serviceAccount.packagesIsp
                              .customerOrganisation.name
                          }}
                        </div>
                        <v-responsive></v-responsive>
                        <v-card-text class="text-xs-center">
                          <div class="grey--text">
                            <b>{{
                              applicationInfo.serviceAccount.packagesIsp.name
                            }}</b>
                          </div>
                          <div class="grey--text">
                            <b>Circuit Number:</b>
                            {{ applicationInfo.serviceAccount.circuitNumber }}
                          </div>
                          <div
                            class="grey--text"
                            v-if="
                              applicationInfo.serviceAccount
                                .initialActivation !== null
                            "
                          >
                            <b>Active From:</b>
                            {{
                              formatDate(
                                applicationInfo.serviceAccount.initialActivation
                              )
                            }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
           </v-flex> -->

          <!-- <v-flex
            shrink
            mb-1
            v-if="
              applicationInfo.serviceAccountId == null &&
              applicationInfo.serviceAccountType != null
            "
          >
            <v-card  class="rounded-card">
              <v-card-text>
                <h3 class="dark-grey--text font-weight-bold">
                  ISP Service Account Information
                </h3>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-card flat class="text-xs-center mb-2 mx-2">
                        <v-responsive></v-responsive>
                        <v-flex xs12 text-xs-center mb-2>
                          <v-layout wrap>
                            <v-flex xs12 sm12 md12 text-xs-left>
                              <v-layout justify-left wrap align-center>
                                <v-flex xs8>
                                  <h3
                                    class="subheading grey--text font-weight-bold"
                                  >
                                    Connection Type:
                                  </h3>
                                </v-flex>
                                <v-flex xs4>
                                  <h3 class="grey--text font-weight-light">
                                    {{ applicationInfo.serviceAccountType }}
                                  </h3>
                                </v-flex>
                                <v-flex
                                  xs8
                                  v-if="
                                    applicationInfo.organisationBridgeTemplate
                                  "
                                >
                                  <h3
                                    class="subheading grey--text font-weight-bold"
                                  >
                                    Device Configuration Type:
                                  </h3>
                                </v-flex>
                                <v-flex
                                  xs4
                                  v-if="
                                    applicationInfo.organisationBridgeTemplate
                                  "
                                >
                                  <h3
                                    class="grey--text font-weight-light"
                                    v-if="
                                      applicationInfo.organisationBridgeTemplate
                                        .type == 'OneDevice'
                                    "
                                  >
                                    One Device
                                  </h3>
                                  <h3
                                    class="grey--text font-weight-light"
                                    v-else-if="
                                      applicationInfo.organisationBridgeTemplate
                                        .type == 'TwoDevice'
                                    "
                                  >
                                    Two Device
                                  </h3>
                                </v-flex>
                                <v-flex
                                  xs8
                                  v-if="
                                    applicationInfo.organisationBridgeTemplate
                                  "
                                >
                                  <h3
                                    class="subheading grey--text font-weight-bold"
                                  >
                                    Inner VLAN:
                                  </h3>
                                </v-flex>
                                <v-flex
                                  xs4
                                  v-if="
                                    applicationInfo.organisationBridgeTemplate
                                  "
                                >
                                  <h3 class="grey--text font-weight-light">
                                    {{
                                      applicationInfo.organisationBridgeTemplate
                                        .innerVlan
                                    }}
                                  </h3>
                                </v-flex>
                                <v-flex
                                  xs8
                                  v-if="
                                    applicationInfo.organisationBridgeTemplate &&
                                    applicationInfo.organisationBridgeTemplate
                                      .outerVlan != 0
                                  "
                                >
                                  <h3
                                    class="subheading grey--text font-weight-bold"
                                  >
                                    Outer VLAN:
                                  </h3>
                                </v-flex>
                                <v-flex
                                  xs4
                                  v-if="
                                    applicationInfo.organisationBridgeTemplate &&
                                    applicationInfo.organisationBridgeTemplate
                                      .outerVlan != 0
                                  "
                                >
                                  <h3 class="grey--text font-weight-light">
                                    {{
                                      applicationInfo.organisationBridgeTemplate
                                        .outerVlan
                                    }}
                                  </h3>
                                </v-flex>
                              </v-layout>
                              <v-layout
                                justify-left
                                v-if="
                                  applicationInfo.serviceAccountType.toLowerCase() ==
                                  'pppoe'
                                "
                              >
                                <v-flex xs8>
                                  <h3
                                    class="subheading grey--text font-weight-bold"
                                  >
                                    PPPoE Username:
                                  </h3>
                                </v-flex>
                                <v-flex xs4>
                                  <h3 class="grey--text font-weight-light">
                                    {{ applicationInfo.pppoeUsername }}
                                  </h3>
                                </v-flex>
                              </v-layout>
                              <v-layout
                                justify-left
                                v-if="
                                  applicationInfo.serviceAccountType.toLowerCase() ==
                                  'pppoe'
                                "
                              >
                                <v-flex xs8>
                                  <h3
                                    class="subheading grey--text font-weight-bold"
                                  >
                                    PPPoE Password:
                                  </h3>
                                </v-flex>
                                <v-flex xs4>
                                  <h3 class="grey--text font-weight-light">
                                    {{ applicationInfo.pppoePassword }}
                                  </h3>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex> -->
          <v-flex
            shrink
            mb-1
            v-if="
              !applicationInfo.isApproved &&
                applicationInfo.packagesIspId !== null &&
                existingServiceAccounts.length > 0
            "
          >
            <v-card class="rounded-card">
              <v-card-text>
                <h3 class="dark-grey--text font-weight-bold">
                  <v-icon color="orange">warning</v-icon>Service Account Clashes
                  <v-btn v-if="applicationInfo.isPackageVerified" round color="primary" disabled>
                    <v-icon color="white">check</v-icon>Verified
                  </v-btn>
                  <v-btn v-else round color="primary" @click="verifyPackage()">Verify</v-btn>
                </h3>
                <v-container grid-list-xs>
                  <v-layout align-center>
                    <v-flex xs1>
                      <v-icon @click="serviceAccountIndex--" v-if="serviceAccountIndex > 0">keyboard_arrow_left</v-icon>
                    </v-flex>
                    <v-flex xs10>
                      <v-card hover class="text-xs-center mb-2 mx-1">
                        <div class="primary subheading text-uppercase white--text">
                          {{ existingServiceAccounts[serviceAccountIndex].packagesIsp.customerOrganisation.name }}
                        </div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                          <div class="grey--text">
                            <v-chip
                              small
                              v-if="existingServiceAccounts[serviceAccountIndex].isSuspended"
                              color="red"
                              class="white--text"
                              >Suspended</v-chip
                            >
                            <v-chip small v-else color="green" class="white--text">Active</v-chip>
                            <b>Circuit Number:</b>
                            {{ existingServiceAccounts[serviceAccountIndex].circuitNumber }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs1>
                      <v-icon
                        @click="serviceAccountIndex++"
                        v-if="serviceAccountIndex < existingServiceAccounts.length - 1"
                        >keyboard_arrow_right</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex grow mb-1 v-if="feasibilityTests.length > 0">
            <v-card min-width="800px" elevation="5" class="rounded-card">
              <v-card-text>
                <h2 class="dark-grey--text font-weight-bold">Line Of Sight</h2>
                <v-layout justify-center align-center wrap>
                  <v-flex xs6>
                    <v-card
                      hover
                      class="mt-1"
                      flat
                      xs12
                      v-for="los in feasibilityTests"
                      :key="los.id"
                      @click="lineChartData = los"
                    >
                      <v-layout justify-left align-center wrap class="grey--text">
                        <v-flex xs4 v-if="los.gisDatum">
                          <h4>{{ los.gisDatum.name }}</h4>
                        </v-flex>
                        <v-flex xs3>
                          <h4 class="font-weight-light">{{ los.distance }}m</h4>
                        </v-flex>
                        <v-flex xs3>
                          <v-chip v-if="los.success" color="light-green" class="white--text">Success</v-chip>
                          <v-chip v-else color="red" class="white--text">Unsuccessful</v-chip>
                        </v-flex>
                        <v-flex xs2>
                          <v-icon v-if="lineChartData && lineChartData.id == los.id" color="light-green"
                            >check_circle_outline</v-icon
                          >
                        </v-flex>
                      </v-layout>
                    </v-card>
                    <v-layout justify-center>
                      <v-flex xs12>
                        <linechart
                          :key="lineChartData"
                          v-if="lineChartData"
                          height="150px"
                          :chartdata="{
                            labels: JSON.parse(lineChartData.data).map((x, index) => index),
                            datasets: [
                              {
                                label: 'LOS',
                                data: JSON.parse(lineChartData.los),
                                backgroundColor: lineChartData.success ? '#99cc33' : '#fc0303',
                                borderColor: lineChartData.success ? '#99cc33' : '#fc0303',
                                borderWidth: 1,
                                fill: false,
                              },
                              {
                                label: 'Elevation',
                                data: JSON.parse(lineChartData.data).map((x) => x.elevation),
                                backgroundColor: '#7cd8eb',
                                borderColor: '#7cd8eb',
                                borderWidth: 1,
                              },
                            ],
                          }"
                          :options="{
                            elements: {
                              point: {
                                radius: 0,
                              },
                            },
                          }"
                        ></linechart>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6>
                    <gmap-map
                      ref="mapRef"
                      :center="center"
                      :zoom="11"
                      :style="[
                        {
                          width: '100%',
                          height: '300px',
                        },
                      ]"
                    >
                      <gmap-polyline
                        v-for="line in feasibilityTests"
                        :path="JSON.parse(line.line)"
                        :key="line.distance"
                        :options="{
                          strokeColor: line.success ? '#99cc33' : 'red',
                        }"
                      >
                      </gmap-polyline>
                      <gmap-custom-marker
                        v-for="marker in feasibilityTests"
                        :key="marker.id"
                        :marker="{
                          lat: marker.gisDatum.lat,
                          lng: marker.gisDatum.lng,
                        }"
                        alignment="center"
                        class="z-index: 5"
                      >
                        <!-- <v-card color="white" class="rounded-card"> -->
                        <v-layout justify-center align-center wrap>
                          <v-flex xs12>
                            <v-avatar>
                              <v-icon class="outlined">podcasts</v-icon>
                            </v-avatar>
                          </v-flex>
                          <v-flex xs12>
                            <v-chip small color="white"
                              ><h3>{{ marker.gisDatum.name }}</h3></v-chip
                            >
                          </v-flex>
                        </v-layout>
                        <!-- </v-card> -->
                      </gmap-custom-marker>
                      <gmap-marker :position="applicationInfo.coordinates"></gmap-marker>
                    </gmap-map>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex :key="key" grow my-1>
            <SageTransactions :transactions="invoices" :taxtypes="taxTypes"></SageTransactions>
            <!-- <v-card class="rounded-card" >
          <v-card-text>
            <h2 class="dark-grey--text">Transactions</h2>
            <div v-if="billingTab == 'invoices'">
              <v-data-table
                :headers="transactionHeaders"
                :items="invoices"
                :rows-per-page-items="[5]"
              >
                <template v-slot:items="props">
                  <td>
                           <v-btn flat color="primary" @click="viewInvoice(props.item)">View</v-btn>
                         </td>
                  <td > {{props.item.DocumentNumber}}</td>
                  <td > {{formatDate(props.item.Date)}}</td>
                  <td > {{props.item.Total | currency}}</td>
                  <td >
                    <v-chip small v-if="props.item.AmountDue<=0" color="light-green" class="white--text">Paid</v-chip>
                    <v-chip small v-else-if="props.item.AmountDue>0&&props.item.AmountDue<props.item.Total" color="orange" class="white--text">Partially Paid</v-chip>
                    <v-chip small v-else-if="props.item.AmountDue == props.item.Total" color="red" class="white--text">Unpaid</v-chip>

                  </td>

                </template>
              </v-data-table>
            </div>
            
            <div v-if="billingTab == 'quote'">
                    <v-data-table :items="quotes" :rows-per-page-items="5" :headers="quoteHeaders">
                       <template v-slot:items="props">
                         <td>
                           <v-btn flat color="primary" @click="viewQuote(props.item)">View</v-btn>
                         </td>
                         <td>{{props.item.document}}</td>
                         <td>{{formatDate(props.item.date)}}</td>
                         <td>{{formatDate(props.item.expires)}}</td>
                         <td>
                           <v-chip color="red" class="white--text" v-if="new Date() > new Date(props.item.expires)">Expired</v-chip>
                           <v-chip color="light-green" class="white--text" v-else-if="props.item.isAccepted">Accepted</v-chip>
                           <v-chip color="orange" class="white--text" v-else-if="props.item.isAccepted==null">Pending</v-chip>
                           <v-chip color="red" class="white--text" v-else-if="!props.item.isAccepted">Rejected</v-chip>
                         </td>
                       </template>
                    </v-data-table>
            </div>
          </v-card-text>
        </v-card> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-dialog v-model="invoiceModal" max-width="1000px" min-width="300px">
      <SageInvoiceModal
        :invoice="invoiceItem"
        :taxtypes="taxTypes"
        :type="'read'"
        @closeModal="(invoiceItem = {}), (invoiceModal = false)"
        @acceptPay="acceptQuote($event)"
      ></SageInvoiceModal>
    </v-dialog>

    <v-dialog v-model="deniedReasonModal" max-width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">
            Please provide a reason for denying the application
          </h3>
        </v-toolbar>
        <v-card-text>
          <v-textarea label="Reason for Rejection" v-model="deniedReason"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" class="white--text" @click="deniedReasonModal = false">Cancel</v-btn>
            <v-btn
              v-if="deniedReason !== '' && deniedReason"
              round
              color="primary"
              class="white--text"
              @click="rejectApplication"
              >Reject Application</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Similar Contacts Modal -->
    <v-dialog v-model="similarContactsModalPrimary" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">SIMILAR CONTACTS</h3>
          <v-spacer></v-spacer>
          <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 sm6 md6 lg6 v-for="person in linkedPrimaryContacts" :key="person.name">
            <v-card hover class="text-xs-center mb-2 mx-2">
              <div class="subheading text-uppercase">{{ person.name }} {{ person.surname }}</div>
              <v-responsive></v-responsive>
              <v-card-text>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">smartphone</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.mobileNumber }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">email</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.emailAddress }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">perm_identity</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.idNumber }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="justify-center layout px-0">
                <v-btn color="light-blue white--text" round @click="mergePrimaryContact(person)">
                  <v-icon small>call_merge</v-icon>Merge
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="similarContactsModalPrimary = false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="attachLocationModal" max-width="800px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">Attach Location</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="attachLocationModal=false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-checkbox label="Attach existing location" v-model="attachExistingLocation"></v-checkbox>
          <v-layout v-if="attachExistingLocation">
            <v-spacer></v-spacer>
            <v-flex xs6 mx-2>
              <v-text-field
                label="Search"
                v-model="search"
                clearable
                append-icon="search"
                v-on:keyup.enter="
                  $router.push({
                    name: $route.name,
                    query: {
                      offset: $route.query.offset,
                      records: $route.query.records,
                      search: search,
                    },
                  })
                "
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-center v-if="attachExistingLocation">
            <v-data-table :items="filteredLocations" :headers="locationHeaders" hide-actions>
              <template v-slot:items="props">
                <td class="text-xs-center">
                  <v-icon @click="attachExisting(props.item.id)" color="primary">add_circle_outline</v-icon>
                </td>
                <td class="text-xs-center">{{ props.item.unitNo }}</td>
                <td class="text-xs-center">{{ props.item.erfNo }}</td>
                <td class="text-xs-center">{{ props.item.otherNo }}</td>
                <td class="text-xs-center">
                  {{ props.item.complexStreetName }}
                </td>
                <td class="text-xs-center" v-if="props.item.locationNetworkSubComplexId !== null">
                  {{ props.item.locationNetworkSubComplex.subcomplexName }}
                </td>
                <td v-else></td>
                <td class="text-xs-center">
                  {{ props.item.locationNetwork.name }}
                </td>
              </template>
            </v-data-table>
          </v-layout>
          <v-layout v-if="attachExistingLocation" justify-center>
            <div class="text-xs-center pt-2 white" :key="$route.query.offset">
              <v-pagination
                v-model="page"
                :length="Math.ceil(locationLength / $route.query.records)"
                :total-visible="7"
              ></v-pagination>
            </div>
          </v-layout>
          <v-container v-if="!attachExistingLocation" grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="locationNetworks"
                  item-text="name"
                  item-value="id"
                  label="*Select an associated Network"
                  v-model="applicationInfo.locationNetworkId"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="subComplexes"
                  item-text="subComplexName"
                  item-value="id"
                  label="Select an associated Sub Complex"
                  v-model="applicationInfo.locationNetworkSubComplexId"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  :items="locationTypes"
                  item-text="name"
                  item-value="id"
                  v-model="applicationInfo.locationTypeId"
                  label="*Location Type"
                  persistent-hint
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.erfNo"
                  label="Erf No"
                  type="number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.unitNumber"
                  label="*Unit No"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="applicationInfo.otherNo" label="Other No" persistent-hint></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.floorNo"
                  label="Floor No"
                  type="number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.streetName"
                  label="Complex Street Name"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="applicationInfo.complexName"
                  label="Complex Name"
                  required
                  persistent-hint
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-layout justify-center v-if="!attachExistingLocation">
            <v-btn round color="primary" v-if="applicationInfo.locationTypeId" @click="createNewLocation()"
              >Create New Location</v-btn
            >
            <v-btn round color="primary" v-else disabled @click="createNewLocation()">Create New Location</v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Similar Contacts Modal -->
    <v-dialog v-model="similarContactsModalSecondary" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">SIMILAR CONTACTS</h3>
          <v-spacer></v-spacer>
          <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 sm6 md6 lg6 v-for="person in linkedSecondaryContacts" :key="person.name">
            <v-card hover class="text-xs-center mb-2 mx-2">
              <div class="subheading text-uppercase">{{ person.name }} {{ person.surname }}</div>
              <v-responsive></v-responsive>
              <v-card-text>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">smartphone</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.mobileNumber }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">email</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.emailAddress }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">perm_identity</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.idNumber }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="justify-center layout px-0">
                <v-btn color="light-blue white--text" round @click="mergeSecondaryContact(person)">
                  <v-icon small>call_merge</v-icon>Merge
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="similarContactsModalSecondary = false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Similar Contacts Modal -->
    <v-dialog v-model="similarContactsModalBilling" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">SIMILAR CONTACTS</h3>
          <v-spacer></v-spacer>
          <!-- <v-btn @click="addContact('Primary')" class='white--text' flat><v-icon class='white--text' >add</v-icon> Create New Contact</v-btn> -->
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 sm6 md6 lg6 v-for="person in linkedBillingContacts" :key="person.name">
            <v-card hover class="text-xs-center mb-2 mx-2">
              <div class="subheading text-uppercase">{{ person.name }} {{ person.surname }}</div>
              <v-responsive></v-responsive>
              <v-card-text>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">smartphone</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.mobileNumber }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">email</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.emailAddress }}</div>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs2 class="text-xs-right">
                    <v-icon small color="grey">perm_identity</v-icon>
                  </v-flex>
                  <v-flex xs8 justify-left>
                    <div class="grey--text">{{ person.idNumber }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="justify-center layout px-0">
                <v-btn color="light-blue white--text" round @click="mergeBillingContact(person)">
                  <v-icon small>call_merge</v-icon>Merge
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="similarContactsModalBilling = false">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Contact -->
    <v-dialog persistent v-model="editContactModal" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">EDIT CONTACT</h3>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="editedContact.name" label="Name"></v-text-field>
          <v-text-field v-model="editedContact.surname" label="Surname"></v-text-field>
          <v-text-field v-model="editedContact.idNumber" label="ID Number"></v-text-field>
          <v-text-field v-model="editedContact.emailAddress" label="Email Address"></v-text-field>
          <v-text-field v-model="editedContact.mobileNumber" label="Mobile Number"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="(editContactModal = false), (editedContact = {})">Cancel</v-btn>
            <v-btn round color="primary" @click="saveEditedContact">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="showProducts" max-width="1000px">
      <v-toolbar flat color="primary">
        <h3 class="title white--text">Products</h3>
        <v-spacer></v-spacer>
        <v-btn flat color="white" @click="showProducts = false">X</v-btn>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field label="Search" append-icon="search" v-model="search"></v-text-field>
      </v-toolbar>
      <v-data-table
        :headers="productHeaders"
        class="elevation-1"
        :items="products"
        :rows-per-page-items="[10, 20, 50, 100, 250]"
        :pagination.sync="pagination"
        item-key="id"
        align-center
        style="cursor: pointer"
        :search="search"
      >
        <template v-slot:items="props">
          <td class="text-xs-center" v-if="props.item.locationNetworkProduct.stockItem">
            {{ props.item.locationNetworkProduct.stockItem.name }}
          </td>
          <td class="text-xs-center" v-else>
            {{ props.item.locationNetworkProduct.deviceMakeModel.name }}
          </td>
          <td class="text-xs-center" v-if="props.item.locationNetworkProduct.stockItem">
            {{ props.item.locationNetworkProduct.stockItem.stockType.name }}
          </td>
          <td class="text-xs-center" v-else>
            {{ props.item.locationNetworkProduct.deviceMakeModel.deviceMake.name }}
          </td>
          <td v-if="props.item.locationNetworkProduct.stockItem" class="text-xs-center">
            {{ (props.item.locationNetworkProduct.stockItem.priceExclVat * (1 + $VAT)) | currency }}
          </td>
          <td v-else class="text-xs-center">
            {{ props.item.locationNetworkProduct.deviceMakeModel.priceInclVat | currency }}
          </td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template
        >
      </v-data-table>
    </v-dialog>

    <!-- Invoice Number Modal -->
    <v-dialog v-model="invoiceNumberDialog" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">INVOICE NUMBER</h3>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="applicationInfo.invoiceNumber" label="Invoice Number"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="(invoiceNumberDialog = false), (applicationInfo.invoiceNumber = '')"
              >Cancel</v-btn
            >
            <v-btn round color="primary" @click="saveInvoiceStatus">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Invoice Number Modal -->
    <v-dialog v-model="xeroContactsModal" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">SIMILAR CONTACTS IN XERO</h3>
        </v-toolbar>
        <v-flex class="mx-3 my-2" xs6 v-for="contact in similarXeroContacts" :key="contact.ContactId">
          <v-card mx-3 my-2 color="white">
            <v-layout row wrap align-center>
              <v-flex xs6>
                <h3 class="subheading grey--text">{{ contact.name }}</h3>
              </v-flex>
              <v-flex xs6>
                <h4 class="subheading grey--text">Name Match: {{ contact.match }}%</h4>
              </v-flex>
              <v-flex xs6>
                <h4 class="subheading font-weight-light grey--text">
                  {{ contact.email }}
                </h4>
              </v-flex>
              <v-flex xs6>
                <v-btn round class="primary"> <v-icon color="white">add</v-icon>Invoice </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="xeroContactsModal = false">Cancel</v-btn>
            <v-btn round color="primary" @click="createXeroContact()">Create New Xero Contact</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ticket View Modal -->
    <v-dialog v-model="viewTicketModal" persistent max-width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">VIEW TICKET: {{ ticketItem.dueDate }}</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" class="white--text" @click="(viewTicketModal = false), (ticketItem = {})">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex xs2>
              <v-checkbox
                v-if="!ticketItem.isSystemGenerated"
                label="Full Day Event"
                v-model="dateTimeSelect"
              ></v-checkbox>
              <v-checkbox v-else disabled label="Full Day Event" v-model="dateTimeSelect"></v-checkbox>
            </v-flex>
            <v-flex xs5>
              <VueCtkDateTimePicker
                v-if="!ticketItem.isSystemGenerated"
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
              <VueCtkDateTimePicker
                v-else
                disabled
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
            </v-flex>
            <v-flex xs5>
              <VueCtkDateTimePicker
                v-if="!ticketItem.isSystemGenerated && !dateTimeSelect"
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              />
              <!-- <VueCtkDateTimePicker
                v-else
                disabled
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              /> -->
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-flex xs3>
              <v-select
                v-if="!ticketItem.isSystemGenerated"
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
              ></v-select>
              <v-select
                v-else
                disabled
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
                @change="ticketItem.ticketCategoryItemId = null"
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-if="!ticketItem.isSystemGenerated && ticketItem.ticketCategoryId"
                xs6
                :items="
                  ticketCategoryItems.filter(
                    (x) => x.ticketCategoryId === ticketItem.ticketCategoryId && x.isActive && !x.isDeleted
                  )
                "
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-select>
              <v-select
                v-else-if="ticketItem.isSystemGenerated"
                disabled
                xs6
                :items="
                  ticketCategoryItems.filter(
                    (x) => x.ticketCategoryId === ticketItem.ticketCategoryId && x.isActive && !x.isDeleted
                  )
                "
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-select>
              <v-select
                v-else
                xs6
                :items="ticketCategories"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-if="!ticketItem.isSystemGenerated"
                :items="statuses"
                label="Status"
                v-model="ticketItem.currentStatus"
              ></v-select>
              <v-select v-else disabled :items="statuses" label="Status" v-model="ticketItem.currentStatus"></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-if="!ticketItem.isSystemGenerated"
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
              ></v-select>
              <v-select
                v-else
                disabled
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4 v-if="!ticketItem.isSystemGenerated">
              <v-autocomplete
                v-model="ticketItem.assignedToId"
                :items="filteredUsers"
                :filter="filterObject"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assign Ticket to a User"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip v-bind="attr" :input-value="selected" color="blue-grey" class="white--text" v-on="on">
                    <v-icon left>person</v-icon>
                    <span>{{ item.name }} {{ item.surname }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item !== 'undefined'"
                  >
                    {{ item.name.charAt(0) }}{{ item.surname.charAt(0) }}
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3">{{ item.name }} {{ item.surname }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <!-- <v-flex  mt-3>
                          <span class="grey--text">System Process</span>
            </v-flex> -->
          </v-layout>
          <v-layout justify-center align-center>
            <v-textarea
              label="Description"
              v-if="!ticketItem.isSystemGenerated"
              outline
              auto-grow
              v-model="ticketItem.description"
            ></v-textarea>
            <v-textarea
              label="Description"
              v-else
              disabled
              outline
              auto-grow
              v-model="ticketItem.description"
            ></v-textarea>
          </v-layout>
          <v-layout justify-center align-center v-if="ticketAssignedLog.length > 0" mb-2>
            <v-flex xs2>
              <h3 class="grey--text">Assignment Log:</h3>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-for="assigned in ticketAssignedLog" :key="assigned.id">
            <v-layout justify-left align-center class="text-xs-left">
              <v-flex xs3>
                <span class="grey--text">{{ formatDateTime(assigned.createdAt) }}</span>
              </v-flex>
              <v-flex xs9>
                <span class="grey--text font-weight-light">
                  <b>{{ assigned.assignedBy.name }} {{ assigned.assignedBy.surname }}</b>
                  assigned the ticket to
                  <b>{{ assigned.assignedTo.name }} {{ assigned.assignedTo.surname }}</b>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-layout justify-center align-center mt-4 mb-2>
            <v-flex xs2>
              <h3 class="grey--text">Comments:</h3>
            </v-flex>
            <v-flex xs1>
              <v-icon color="primary" @click="addCommentBox = true">add_circle_outline</v-icon>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="ticketCommentLog.length === 0 && !addCommentBox">
            <h3 class="grey--text font-weight-light">No Comments</h3>
          </v-flex>
          <v-flex xs12 v-if="addCommentBox">
            <v-textarea label="Comment" outline auto-grow v-model="comment"></v-textarea>
            <v-btn round color="primary" class="white--text" @click="addCommentEditedTicket(comment)">Comment</v-btn>
          </v-flex>
          <v-flex xs12 v-for="comment in ticketCommentLog" :key="comment.createdAt">
            <v-layout justify-left align-center class="text-xs-left">
              <v-flex xs2>
                <span class="grey--text font-weight-light">{{ formatDateTime(comment.createdAt) }}</span>
              </v-flex>
              <v-flex xs2>
                <span class="grey--text font-weight-bold"
                  >{{ comment.commentedBy.name }} {{ comment.commentedBy.surname }}</span
                >
              </v-flex>

              <v-flex xs8>
                <span class="grey--text font-weight-light">{{ comment.comment }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Ticket Add Modal -->
    <v-dialog v-model="addTicketModal" persistent max-width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">ADD TICKET</h3>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              ticketItem.ticketCategoryId &&
                ticketItem.ticketCategoryItemId &&
                ticketItem.currentStatus &&
                ticketItem.importance
            "
            flat
            color="white"
            class="white--text"
            @click="createNewTicket()"
            >Save</v-btn
          >
          <v-btn v-else disabled flat>Save</v-btn>
          <v-btn flat color="white" class="white--text" @click="(addTicketModal = false), (ticketItem = {})">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex xs2>
              <v-checkbox
                v-if="!ticketItem.isSystemGenerated"
                label="Full Day Event"
                v-model="dateTimeSelect"
              ></v-checkbox>
              <v-checkbox v-else disabled label="Full Day Event" v-model="dateTimeSelect"></v-checkbox>
            </v-flex>
            <v-flex xs5>
              <VueCtkDateTimePicker
                v-if="!ticketItem.isSystemGenerated"
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
              <VueCtkDateTimePicker
                v-else
                disabled
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
            </v-flex>
            <v-flex xs5>
              <VueCtkDateTimePicker
                v-if="!ticketItem.isSystemGenerated && !dateTimeSelect"
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              />
              <!-- <VueCtkDateTimePicker
                v-else
                disabled
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              /> -->
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-flex xs3>
              <v-select
                v-if="!ticketItem.isSystemGenerated"
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
              ></v-select>
              <v-select
                v-else
                disabled
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketCategoryId"
              ></v-select>
            </v-flex>
            <v-flex xs3 :key="ticketItem.ticketCategoryId">
              <v-select
                v-if="!ticketItem.isSystemGenerated && ticketItem.ticketCategoryId"
                xs6
                :items="filteredCategoryItems"
                :disabled="!ticketItem.ticketCategoryId"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-select>
              <v-select
                v-else-if="ticketItem.isSystemGenerated"
                disabled
                xs6
                :items="filteredCategoryItems"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-select>
              <v-select
                v-else
                disabled
                xs6
                :items="filteredCategoryItems"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-if="!ticketItem.isSystemGenerated"
                :items="statuses"
                label="Status"
                v-model="ticketItem.currentStatus"
              ></v-select>
              <v-select v-else disabled :items="statuses" label="Status" v-model="ticketItem.currentStatus"></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-if="!ticketItem.isSystemGenerated"
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
              ></v-select>
              <v-select
                v-else
                disabled
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
              ></v-select>
            </v-flex>
          </v-layout>
          <!-- <v-layout>
            <v-flex xs4 v-if="!ticketItem.isSystemGenerated">
              <v-autocomplete
                v-model="ticketItem.assignedToId"
                :items="filteredUsers"
                :filter="filterObject"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assign Ticket to a User"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip
                    v-bind="attr"
                    :input-value="selected"
                    color="blue-grey"
                    class="white--text"
                    v-on="on"
                  >
                    <v-icon left>person</v-icon>
                    <span>{{ item.name }} {{ item.surname }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item !== 'undefined'"
                  >
                    {{ item.name.charAt(0) }}{{ item.surname.charAt(0) }}
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3"
                      >{{ item.name }} {{ item.surname }}</v-list-item-title
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-flex>
            
          </v-layout> -->

          <v-layout>
            <v-flex xs3 mx-2>
              <v-autocomplete
                clearable
                :items="userRoles"
                label="User Role"
                item-text="name"
                item-value="id"
                v-model="ticketItem.userRoleId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-2>
              <v-autocomplete
                v-if="ticketItem.userRoleId"
                v-model="ticketItem.assignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assign Ticket to a User"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip v-bind="attr" :input-value="selected" color="blue-grey" class="white--text" v-on="on">
                    <v-icon left>person</v-icon>
                    <span>{{ item.name }} {{ item.surname }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item !== 'undefined'"
                    >{{ item.name.charAt(0) }}{{ item.surname.charAt(0) }}</v-avatar
                  >
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3">{{ item.name }} {{ item.surname }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-else
                disabled
                v-model="filterAssignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assigned User"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs3 mx-1 v-if="applicationInfo.packagesIspId">
              <v-checkbox v-model="ticketItem.shareWithIsp" label="Allow ISP to view Ticket"></v-checkbox>
            </v-flex>
            <!-- <v-flex  mt-3>
                          <span class="grey--text">System Process</span>
            </v-flex> -->
          </v-layout>

          <v-layout justify-center align-center>
            <v-textarea
              label="Description"
              v-if="!ticketItem.isSystemGenerated"
              outline
              auto-grow
              v-model="ticketItem.description"
            ></v-textarea>
            <v-textarea
              label="Description"
              v-else
              disabled
              outline
              auto-grow
              v-model="ticketItem.description"
            ></v-textarea>
          </v-layout>
          <!-- <v-layout justify-center align-center v-if="ticketAssignedLog.length>0" mb-2>
            <v-flex xs2>
              <h3 class="grey--text">Assignment Log:</h3>
            </v-flex>
          </v-layout> -->
          <!-- <v-flex xs12 v-for="assigned in ticketAssignedLog" :key="assigned.id">
            <v-layout justify-left align-center class="text-xs-left">
              <v-flex xs3>
                <span class="grey--text">{{formatDateTime(assigned.createdAt)}}</span>
              </v-flex>
              <v-flex xs9>
                <span class="grey--text font-weight-light">
                  <b>{{assigned.assignedBy.name}} {{assigned.assignedBy.surname}}</b>
                  assigned the ticket to
                  <b>{{assigned.assignedTo.name}} {{assigned.assignedTo.surname}}</b>
                </span>
              </v-flex>
            </v-layout>
          </v-flex> -->

          <v-layout justify-center align-center mt-4 mb-2>
            <v-flex xs2>
              <h3 class="grey--text">Comments:</h3>
            </v-flex>
            <v-flex xs1>
              <v-icon color="primary" @click="addCommentBox = true">add_circle_outline</v-icon>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="ticketCommentLog.length === 0 && !addCommentBox">
            <h3 class="grey--text font-weight-light">No Comments</h3>
          </v-flex>
          <v-flex xs12 v-if="addCommentBox">
            <v-textarea label="Comment" outline auto-grow v-model="comment"></v-textarea>
            <v-btn round color="primary" class="white--text" @click="addComment(comment)">Comment</v-btn>
          </v-flex>
          <v-layout>
            <v-card flat style="overflow-y: auto; max-height: 1000px">
              <v-container style="text-align: left">
                <v-layout wrap>
                  <v-flex xs12 v-for="comment in ticketCommentLog" :key="comment.createdAt">
                    <v-layout justify-left align-center class="text-xs-left">
                      <v-flex xs2>
                        <span class="grey--text font-weight-light">{{ formatDateTime(comment.createdAt) }}</span>
                      </v-flex>
                      <v-flex xs2>
                        <span class="grey--text font-weight-bold"
                          >{{ comment.commentedBy.name }} {{ comment.commentedBy.surname }}</span
                        >
                      </v-flex>

                      <v-flex xs8>
                        <span class="grey--text font-weight-light">{{ comment.comment }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Provisioning Warning Modal -->
    <v-dialog v-model="provisionWarningModal" persistent max-width="450px" min-width="450px">
      <v-card flat color="white">
        <v-toolbar flat color="orange">
          <h3 class="title white--text">Conflict</h3>
          <v-spacer></v-spacer>
          <v-btn v-if="authAdmin($store.state.currentRoute)" flat color="white" @click="provisionWarningModal = false"
            >X</v-btn
          >
        </v-toolbar>
        <v-card-text v-if="!authAdmin($store.state.currentRoute) && provisionTemplate">
          <span mx-4 class="grey--text"
            >The provisioning template for this ISP is set to provision on Ethernet port
            {{ provisionTemplate.tpIndex }}, there is however already an existing service on this port. Please contact
            your system administrator for further assistance.</span
          >
        </v-card-text>
        <v-card-text v-else-if="provisionTemplate">
          <span mx-4 class="grey--text">
            There are already services provisioned on Ethernet port
            {{ provisionTemplate.tpIndex }}.
            <br />
            <br />
          </span>
          <v-select
            xs3
            v-if="ethPorts.filter((x) => !deviceBridges.map((y) => y.tpIndex).includes(x)).length > 0"
            v-model="changedPort"
            label="Please select another port to provision services"
            :items="ethPorts.filter((x) => !deviceBridges.map((y) => y.tpIndex).includes(x))"
          ></v-select>
          <span class="grey--text" v-else>There are currently no unprovisioned ports.</span>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              v-if="!authAdmin($store.state.currentRoute)"
              round
              color="primary"
              class="white--text"
              @click="provisionWarningModal = false"
              >Okay</v-btn
            >
            <v-btn
              v-if="ethPorts.filter((x) => !deviceBridges.map((y) => y.tpIndex).includes(x)).length == 0"
              round
              color="primary"
              class="white--text"
              @click="provisionWarningModal = false"
              >Okay</v-btn
            >
            <v-btn
              v-else-if="authAdmin($store.state.currentRoute)"
              round
              color="primary"
              class="white--text"
              @click="processPortChange()"
              >Process</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addCustomerModal" persistent width="800px">
      <v-card color="white" flat>
        <v-toolbar color="primary" flat>
          <h3 class="title white--text">ADD DATATILL CUSTOMER</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="addCustomerModal = false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-if="existingDatatillCustomer">
            <v-layout justify-center align-center wrap>
              <h3 style="color: grey">
                Please select a customer from the existing DataTill customers found
              </h3>
              <v-flex xs4 mx-1 mt-2 v-for="found in foundExisting" :key="found.customerId">
                <div
                  name="packageCard"
                  :id="found.customerId"
                  class="elevation-5 ma-2 pa-2"
                  style="text-align: center; padding: 0px; cursor: pointer"
                  :class="{ greenBorder: found.customerId == keepColorId }"
                  @click="selectExistingCustomer(found)"
                  hover
                >
                  <div class="primary subheading text-uppercase white--text">
                    {{ found.type }}
                  </div>
                  <v-responsive></v-responsive>
                  <v-card-text>
                    <div class="subheading">{{ found.fullName }}</div>
                    <v-layout v-if="found.mobile !== null">
                      <v-flex xs2 class="text-xs-right">
                        <v-icon small color="grey">smartphone</v-icon>
                      </v-flex>
                      <v-flex xs8 justify-left>
                        <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden">
                          {{ found.mobile }}
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="found.email !== null">
                      <v-flex xs2 class="text-xs-right">
                        <v-icon small color="grey">email</v-icon>
                      </v-flex>
                      <v-flex xs8 justify-left>
                        <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden">
                          {{ found.email }}
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="found.idNumber !== null">
                      <v-flex xs2 class="text-xs-right">
                        <v-icon small color="grey">perm_identity</v-icon>
                      </v-flex>
                      <v-flex xs8 justify-left>
                        <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden">
                          {{ found.idNumber }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <v-layout>
              <v-checkbox label="Create a new DataTill customer" v-model="createNewDatatillCustomer"></v-checkbox>
            </v-layout>
            <div v-if="createNewDatatillCustomer === true">
              <v-layout>
                <v-flex xs6 mx-3>
                  <v-autocomplete
                    xs6
                    :items="datatillContactTypeList"
                    label="Select contact to add to DataTill"
                    v-model="datatillContactType"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 mx-3>
                  <v-card hover class="text-xs-center mb-2 mx-2">
                    <div class="primary subheading text-uppercase white--text">
                      {{ datatillContactType }}
                    </div>
                    <v-responsive></v-responsive>
                    <v-card-text>
                      <div class="subheading">{{ newCustomer.fullName }}</div>
                      <v-layout v-if="newCustomer.mobileNumber !== null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">smartphone</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden">
                            {{ newCustomer.mobileNumber }}
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="newCustomer.emailAddress !== null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">email</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden">
                            {{ newCustomer.emailAddress }}
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="newCustomer.idNumber !== null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">perm_identity</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden">
                            {{ newCustomer.idNumber }}
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
            <div v-else>
              <h3 style="color: grey">
                Please select a customer from the existing DataTill customers found
              </h3>
              <v-layout wrap>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search3"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  class="pa-3"
                  clearable
                ></v-text-field>
              </v-layout>
              <v-data-table
                v-model="selected"
                :rows-per-page-items="[10, 25, 50, 100]"
                :headers="customerSearchHeaders"
                :items="allCustomers"
                :pagination.sync="pagination"
                :search="search3"
                item-key="id"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <tr :active="props.selected" @click="props.selected = !props.selected">
                    <td>
                      <v-checkbox
                        :input-value="props.selected"
                        primary
                        @click="selected = []"
                        hide-details
                      ></v-checkbox>
                    </td>

                    <td class="text-xs-center">
                      {{ props.item.accounting_code }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.contact_name }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.contact_email }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.contact_mobile }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-layout>
            <v-spacer></v-spacer>
            <v-btn
              round
              color="primary"
              class="white--text"
              v-if="!existingDatatillCustomer && createNewDatatillCustomer && datatillContactType"
              @click="
                addCustomerModal = false;
                ispVerifyModal();
              "
              >NEXT</v-btn
            >
            <v-btn
              round
              color="primary"
              class="white--text"
              v-else-if="
                !existingDatatillCustomer && !createNewDatatillCustomer && applicationInfo.datatillCustomerId !== null
              "
              @click="
                addCustomerModal = false;
                ispVerifyModal();
              "
              >NEXT</v-btn
            >
            <v-btn
              round
              color="primary"
              class="white--text"
              v-else-if="existingDatatillCustomer && selectedExistingCustomer"
              @click="
                addCustomerModal = false;
                ispVerifyModal();
              "
              >NEXT</v-btn
            >
            <v-btn round color="primary" class="white--text" v-else disabled>NEXT</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="configModal" width="750px">
      <v-card color="white" flat>
        <v-toolbar color="primary" flat>
          <h3 class="title white--text">SERVICE CONFIGURATION</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="(configModal = false), (configurationSettings = {})">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-if="configurationSettings.type == 'Multiple'">
            <v-layout justify-center align-center wrap>
              <v-flex xs10 mx-1 my-1 v-if="configurationSettings.bridgeTemplates.length > 1">
                <h4 class="grey--text">
                  There are multiple configurations available for this device. Please choose the preferred
                  configuration:
                </h4>
              </v-flex>
              <v-flex xs8 mx-1 mt-2 v-for="template in configurationSettings.bridgeTemplates" :key="template.id">
                <v-card
                  color="white"
                  :hover="configurationSettings.selectedTemplateId !== template.id"
                  @click="
                    (configurationSettings.selectedTemplateId = template.id),
                      (configurationSettings.connectionType = template.connectionType)
                  "
                >
                  <v-toolbar
                    flat
                    :color="configurationSettings.selectedTemplateId == template.id ? 'light-green' : 'primary'"
                  >
                    <h3 class="title white--text" v-if="template.type == 'OneDevice'">
                      One Device
                    </h3>
                    <h3 class="title white--text" v-else>Two Device</h3>
                    <v-spacer></v-spacer>
                    <v-icon large v-if="configurationSettings.selectedTemplateId == template.id" color="white"
                      >check_circle</v-icon
                    >
                  </v-toolbar>
                  <v-card-text>
                    <v-layout justify-left align-center mx-1 wrap class="text-xs-left">
                      <v-flex xs4 mx-1>
                        <h3 class="grey--text">Connection Type:</h3>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <h3 class="grey--text font-weight-light">
                          {{ template.connectionType }}
                        </h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.innerVlan != 0">
                        <h3 class="grey--text">Inner VLAN:</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.innerVlan != 0">
                        <h3 class="grey--text font-weight-light">
                          {{ template.innerVlan }}
                        </h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.outerVlan != 0">
                        <h3 class="grey--text">Outer VLAN:</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.outerVlan != 0">
                        <h3 class="grey--text font-weight-light">
                          {{ template.outerVlan }}
                        </h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.type == 'TwoDevice'">
                        <h3 class="red--text">Terms:</h3>
                      </v-flex>
                      <v-flex xs6 mx-1 v-if="template.type == 'TwoDevice'">
                        <h3 class="red--text font-weight-light">
                          Second device is NOT provided by the network operator and will need to either be supplied by
                          the ISP or the end customer.
                        </h3>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div
            v-if="configurationSettings.connectionType && configurationSettings.connectionType.toLowerCase() == 'pppoe'"
          >
            <v-layout align-center justify-center wrap my-1>
              <v-flex xs10 mx-1 mt-2>
                <h3 class="title grey--text">PPPoE Configuration</h3>
              </v-flex>
              <v-flex xs4 mx-1>
                <v-text-field label="PPPoE Username" v-model="configurationSettings.pppoeUsername"></v-text-field>
              </v-flex>
              <v-flex xs4 mx-1>
                <v-text-field
                  label="PPPoE Password"
                  placeholder="Leave blank to auto-generate"
                  v-model="configurationSettings.pppoePassword"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center align-center>
            <v-btn
              round
              color="primary"
              class="white--text"
              v-if="
                configurationSettings.selectedTemplateId &&
                  configurationSettings.connectionType &&
                  configurationSettings.connectionType.toLowerCase() != 'pppoe'
              "
              @click="submitConfiguration()"
              >Submit</v-btn
            >
            <v-btn
              round
              color="primary"
              class="white--text"
              v-else-if="
                configurationSettings.selectedTemplateId &&
                  configurationSettings.connectionType &&
                  configurationSettings.connectionType.toLowerCase() == 'pppoe' &&
                  configurationSettings.pppoeUsername
              "
              @click="submitConfiguration()"
              >Submit</v-btn
            >
            <v-btn round color="primary" class="white--text" v-else disabled>Submit</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Available Secondary Devices -->
    <v-dialog v-model="addSecondaryDeviceModal" width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="white--text">Available Secondary Devices</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="addSecondaryDeviceModal = false">X</v-btn>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field placeholder="Search" v-model="secondaryDeviceSearch"></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            style="cursor: pointer"
            :items="availableSecondaryDeviceList"
            :headers="secondaryDeviceHeader"
            :search="secondaryDeviceSearch"
          >
            <template v-slot:items="props">
              <td class="text-xs-center" @click="selectSecondaryDevice(props.item)">
                {{ props.item.deviceMakeModel.name }}
              </td>
              <td class="text-xs-center" @click="selectSecondaryDevice(props.item)">{{ props.item.ponMac }}</td>
              <td class="text-xs-center" @click="selectSecondaryDevice(props.item)">{{ props.item.serialNumber }}</td>
              <td class="text-xs-center" @click="selectSecondaryDevice(props.item)">
                {{ props.item.stockWarehouse.name }}
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import DeviceCrud from "@/components/DeviceCrud.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import LineChart from "../components/LineChart";
import DocumentCard from "@/components/DocumentCard.vue";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import SageInvoiceModal from "../components/SageInvoiceModal";
import SageTransactions from "../components/SageTransactions";
import At from "vue-at";
import AtTa from "vue-at/dist/vue-at-textarea"; // for textarea
export default {
  components: {
    "gmap-custom-marker": GmapCustomMarker,
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    documentcomponent: DocumentCard,
    linechart: LineChart,
    SageInvoiceModal,
    SageTransactions,
    At,
    AtTa,
  },
  data() {
    return {
      members: [],
      membersEmail: [],
      commentArray: [],
      internal: true,
      mentioned: null,
      emailAddressArray: [],
      serviceAccountIndex: 0,
      ageAnalysis: null,
      center: { lng: -33.919473, lat: 18.427059 },
      ticketCarousalArray: [],
      ticketIndex: 0,
      applicationContactIndex: 0,
      bridgeTemplates: [],
      configurationSettings: {},
      configModal: false,
      datatillIntegration: false,
      datatillContactType: null,
      datatillContactTypeList: [],
      documents: [],
      allCustomers: [],
      addCustomerModal: false,
      createNewDatatillCustomer: true,
      existingDatatillCustomer: false,
      selected: [],
      newCustomer: {},
      foundExisting: [],
      index: 0,
      pages: [],
      stepperModel: null,
      initialAccessBuildFee: 0,
      initialAccessBuildDocument: "",
      keyAdditionalAccessBuildDocument: 0,
      ticketCategoryId: null,
      feasibilityTests: [],
      lineChartData: null,
      userRoles: [],
      productHeaders: [
        {
          text: "Name",
          align: "center",
          value: "locationNetworkProduct.stockItem.name",
        },
        {
          text: "Type",
          align: "center",
          value: "locationNetworkProduct.stockItem.stockType.name",
        },
        {
          text: "Price Incl. VAT",
          align: "center",
          value: "locationNetworkProduct.stockItem.priceExclVat",
        },
      ],
      showProducts: false,
      products: [],
      locations: [],
      locationLength: 0,
      subComplexes: [],
      locationTypes: [],
      locationHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo",
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo",
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo",
        },
        {
          text: "Street Name",
          align: "center",
          value: "complexStreetName",
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubComplex.subcomplexName",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
      ],
      secondaryDeviceHeader: [
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name",
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac",
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber",
        },
        {
          text: "Warehouse",
          align: "center",
          value: "stockWarehouse.name",
        },
      ],
      secondaryDeviceSearch: "",
      keySearch: 0,
      availableSecondaryDeviceList: [],
      addSecondaryDeviceModal: false,
      secondaryDevice: null,
      secondaryDeviceKey: 0,
      locationSearch: "",
      filteredLocations: [],
      locationFilter: null,
      locationNetworks: [],
      attachExistingLocation: false,
      attachLocationModal: false,
      snackbar: false,
      text: "",
      editedContact: {},
      editContactModal: false,
      invoice: null,
      invoiceNumberDialog: false,
      loadingApplication: false,
      xeroContacts: [],
      similarXeroContacts: [],
      installation: {},
      today: this.formatDate(new Date()),
      addInstallationModal: false,
      deniedReasonModal: false,
      filteredUsers: [],
      applicationInfo: "",
      search: "",
      page: 1,
      allDevices: [],
      device: null,
      existingServiceAccounts: [],
      locationContacts: [],
      showApplicationContacts: true,
      showLocationContacts: false,
      linkedPrimaryContacts: [],
      linkedSecondaryContacts: [],
      deniedReason: "",
      linkedBillingContacts: [],
      similarContactsModalPrimary: false,
      similarContactsModalSecondary: false,
      similarContactsModalBilling: false,
      xeroContactsModal: false,
      billedXeroContactId: null,
      provisionTemplate: null,
      verifyingContact: false,
      verifyingInstallation: false,
      verifyingDevice: false,
      creatingPrimaryContact: false,
      creatingSecondaryContact: false,
      creatingBillingContact: false,
      allVlans: [],
      tickets: [],
      addTicketModal: false,
      ticketItem: {
        ticketCategoryId: 2,
      },
      ticketCommentLog: [],
      ticketAssignedLog: [],
      deviceBridges: [],
      provisionWarningModal: false,
      ethPorts: [1, 2, 3, 4],
      changedPort: null,
      ticketKey: 0,
      dateTimeSelect: false,
      y: "top",
      devicesLength: 0,
      pagination: { totalItems: 0 },
      invoices: [],
      quotes: [],
      transactions: [],
      billingTab: "invoices",
      invoiceItem: {},
      invoiceModal: false,
      taxTypes: [],
      tabs: [
        { name: "applicationContacts", displayName: "Application Contacts" },
        { name: "locationContacts", displayName: "Location Contacts" },
      ],
      transactionHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Document No.",
          align: "center",
          value: "DocumentNumber",
        },
        {
          text: "Date",
          align: "center",
          value: "Date",
        },
        {
          text: "Amount",
          align: "center",
          value: "Total",
        },
        {
          text: "Status",
          align: "center",
          value: "AmountDue",
        },
      ],
      locationTypeList: ["End Location", "Location Network", "Location Node", "Switching Centre"],
      locationType: "End Location",
      tributeOptions: { lookup: "name", values: this.users },
      addCommentBox: false,
      comment: "",
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      ticketCategoryItems: [],
      filteredCategoryItems: [],
      ticketCategories: [],
      ticketItem: {},
      headers: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "System Name",
          align: "center",
          value: "systemName",
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
        {
          text: "Node",
          align: "center",
          value: "locationNode.name",
        },
        {
          text: "Switching Centre",
          align: "center",
          value: "switchingCentre.name",
        },
        {
          text: "Make",
          align: "center",
          value: "deviceMakeModel.deviceMake.name",
        },
        {
          text: "Type",
          align: "center",
          value: "deviceMakeModel.deviceType.name",
        },
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name",
        },
        {
          text: "IP Address",
          align: "center",
          value: "ipAddress",
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber",
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac",
        },
        {
          text: "Mac Address",
          align: "center",
          value: "macAddress",
        },
        {
          text: "Pon Numerical",
          align: "center",
          value: "ponNumerical",
        },
        {
          text: "Product Number",
          align: "center",
          value: "productNumber",
        },

        {
          text: "Upstream Device",
          align: "center",
          value: "upstreamDevice.deviceMakeModel.name",
        },
        {
          text: "PON Address",
          align: "center",
          value: "ponAddress",
        },
        {
          text: "PON ID",
          align: "center",
          value: "ponId",
        },
        {
          text: "Frame",
          align: "center",
          value: "frame",
        },
        {
          text: "Slot",
          align: "center",
          value: "slot",
        },
        {
          text: "Port",
          align: "center",
          value: "port",
        },
        {
          text: "Note",
          align: "center",
          value: "note",
        },
        {
          text: "Active",
          align: "center",
          value: "isActive",
        },
      ],
    };
  },
  async created() {
    this.commentArray = [];
    this.$router.push({
      name: this.$route.name,
      query: { offset: "0", records: "10" },
    });
    this.initialize();
  },
  computed: {
    formattedAddress(){
      let address = ''
      if(this.applicationInfo.unitNo){
        address += 'Unit '+this.applicationInfo.unitNo +', '
      }
      if(this.applicationInfo.floorNo){
        address += 'Floor '+this.applicationInfo.floorNo +', '
      }
      if(this.applicationInfo.building){
        address += this.applicationInfo.building +', '
      }
      if(this.applicationInfo.streetNumber){
        address += this.applicationInfo.streetNumber +' '
      }
      if(this.applicationInfo.streetName){
        address += this.applicationInfo.streetName +', '
      }
      if(this.applicationInfo.suburb){
        address += this.applicationInfo.suburb +', '
      }
      if(this.applicationInfo.town){
        address +=this.applicationInfo.town +', '
      }
      if(this.applicationInfo.province){
        address += this.applicationInfo.province +', '
      }
      if(this.applicationInfo.country){
        address += this.applicationInfo.country
      }
      if(this.applicationInfo.postalCode){
        address +=  ' ' + this.applicationInfo.postalCode
      }
      return address
    }
  },
  watch: {
    "ticketItem.ticketCategoryId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.filteredCategoryItems = await this.ticketCategoryItems.filter(function(el) {
            return el.ticketCategoryId === value;
          });
        } else {
          this.filteredCategoryItems = this.ticketCategoryItems;
        }
      },
    },
    "$vuetify.breakpoint.lgAndDown": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
        } else {
          this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
        }
      },
    },
    selected(value) {
      if (value && value.length > 0) {
        this.applicationInfo.datatillCustomerId = value[0].id;
      } else {
        this.applicationInfo.datatillCustomerId = null;
      }
    },
    datatillContactType(value) {
      if (value === "Primary") {
        this.newCustomer.fullName =
          this.applicationInfo.primaryContactFirstname + " " + this.applicationInfo.primaryContactLastname;
        this.newCustomer.idNumber = this.applicationInfo.primaryContactIdNumber;
        this.newCustomer.mobileNumber = this.applicationInfo.primaryContactMobileNumber;
        this.newCustomer.telephoneNumber = this.applicationInfo.primaryContactMobileNumber;
        this.newCustomer.emailAddress = this.applicationInfo.primaryContactEmailAddress;
      } else if (value === "Secondary") {
        this.newCustomer.fullName =
          this.applicationInfo.secondaryContactFirstname + " " + this.applicationInfo.secondaryContactLastname;
        this.newCustomer.idNumber = this.applicationInfo.secondaryContactIdNumber;
        this.newCustomer.mobileNumber = this.applicationInfo.secondaryContactMobileNumber;
        this.newCustomer.telephoneNumber = this.applicationInfo.secondaryContactMobileNumber;
        this.newCustomer.emailAddress = this.applicationInfo.secondaryContactEmailAddress;
      } else if (value === "Billing") {
        this.newCustomer.fullName =
          this.applicationInfo.billingContactFirstname + " " + this.applicationInfo.billingContactLastname;
        this.newCustomer.idNumber = this.applicationInfo.billingContactIdNumber;
        this.newCustomer.mobileNumber = this.applicationInfo.billingContactMobileNumber;
        this.newCustomer.telephoneNumber = this.applicationInfo.billingContactMobileNumber;
        this.newCustomer.emailAddress = this.applicationInfo.billingContactEmailAddress;
      }
    },
    "ticketItem.userRoleId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.ticketItem.assignedToId = null;
          Api()
            .get("/userRoleContact/byUserRole/" + value)
            .then((response) => {
              this.filteredUsers = response.data.map((x) => x.contact);
            });
        }
      },
    },
    filterUserRole: {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          Api()
            .get("/userRoleContact/byUserRole/" + value)
            .then((response) => {
              this.filteredAssignedUsers = response.data.map((x) => x.contact);
            });
        } else {
          this.filteredAssignedUsers = this.filteredUsers;
        }
      },
    },
    users(value) {
      if (value.length > 0) {
        this.filteredUsers = this.users;
      }
    },
    "ticketItem.assignedToId": {
      immediate: true,
      handler(value) {
        if (this.editTicketModal && value !== this.initialAssignedId) {
          if (this.ticketItem.id && value !== null && typeof value !== "undefined") {
            Api()
              .post("/ticketAssignLog", {
                ticketId: this.ticketItem.id,
                assignedToId: this.ticketItem.assignedToId,
              })
              .then((response) => {
                let find = this.users.find((x) => x.id === value);
                response.data.assignedTo = find;
                response.data.assignedBy = this.$store.state.user;
                this.ticketAssignedLog.push(response.data);
              });
            Api().put("/ticket/" + this.ticketItem.id, {
              assignedToId: this.ticketItem.assignedToId,
            });
          }
        }
      },
    },
    "applicationInfo.locationNetworkId": {
      immediate: true,
      async handler(value) {
        if (value) {
          Api()
            .get("/locationNetworkSubcomplex/bynetwork/" + value)
            .then((response) => {
              this.subComplexes = response.data;
            });
        }
      },
    },
    "$route.query.search": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (this.$route.query.search && value !== "" && value != null) {
          Api()
            .get("/devices/active", {
              params: {
                search: value,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allDevices = response.data.result;
              this.pagination.totalItems = response.data.count;
              this.devicesLength = response.data.count;
              this.isLoading = false;
            });
        } else if (this.$route.query.offset && this.$route.query.records) {
          Api()
            .get("/devices/active", {
              params: {
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allDevices = response.data.result;
              this.pagination.totalItems = response.data.count;
              this.devicesLength = response.data.count;
              this.isLoading = false;
            });
        }
      },
    },
    "$route.query.offset": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.search &&
          this.$route.query.search != "" &&
          this.$route.query.search !== null
        ) {
          Api()
            .get("/devices/active", {
              params: {
                search: this.$route.query.search,
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.devices = response.data;
              this.devicesLength = this.devices.length;
              this.isLoading = false;
            });
        } else if (value !== "" && value != null) {
          Api()
            .get("/devices/active", {
              params: {
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allDevices = response.data.result;
              this.pagination.totalItems = response.data.count;
              this.devicesLength = response.data.count;
              this.isLoading = false;
            });
        }
      },
    },
    page(value) {
      this.pagination.page = this.page;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
            },
          });
        }
      }
    },
    locationFilter(value) {
      if (value !== null && typeof value !== "undefined") {
        this.filteredLocations = this.locations.filter(function(el) {
          return el.locationNetworkId === value;
        });
        this.locationLength = this.filteredLocations.length;
      } else {
        this.filteredLocations = this.locations;
        this.locationLength = this.filteredLocations.length;
      }
    },
    "$route.query.search": {
      immediate: true,
      handler(value) {
        if (this.$route.query.search && value !== "" && value != null) {
          Api()
            .get("/Locations/byNetwork/" + this.applicationInfo.locationNetworkId + "/activeFilter", {
              params: {
                search: value,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
            });
        } else if (this.$route.query.offset) {
          Api()
            .get("/Locations/byNetwork/" + this.applicationInfo.locationNetworkId + "/activeFilter", {
              params: {
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
            });
        }
      },
    },
    "$route.query.offset": {
      immediate: true,
      handler(value) {
        this.loading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.search &&
          this.$route.query.search != "" &&
          this.$route.query.search !== null
        ) {
          Api()
            .get("/Locations/byNetwork/" + this.applicationInfo.locationNetworkId + "/activeFilter", {
              params: {
                search: this.$route.query.search,
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
            });
        } else if (value !== "" && value != null) {
          Api()
            .get("/Locations/byNetwork/" + this.applicationInfo.locationNetworkId + "/activeFilter", {
              params: {
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
            });
        }
      },
    },
  },
  methods: {
    async addSecondaryDevice() {
      await this.availableSecondaryDevices();
      this.addSecondaryDeviceModal = true;
      // await Api()
      //   .post("/devices/assignSecondaryDevice/" + this.applicationInfo.id)
      //   .then((res) => {
      //     this.applicationInfo.secondaryDeviceId = res.data.id;
      //     this.secondaryDevice = res.data;
      //     this.secondaryDeviceKey += 1;
      //   });
    },
    async availableSecondaryDevices() {
      await Api()
        .get("/devices/availableSecondaryDevice")
        .then((res) => {
          // this.applicationInfo.secondaryDeviceId = res.data.id;
          this.availableSecondaryDeviceList = res.data;
          // this.secondaryDeviceKey += 1;
        });
    },
    async selectSecondaryDevice(item) {
      await Api()
        .post("/devices/assignSecondaryDevice/" + this.applicationInfo.id + "/" + item.id)
        .then((res) => {
          this.applicationInfo.secondaryDeviceId = res.data.id;
          this.secondaryDevice = res.data;
          this.secondaryDeviceKey += 1;
          this.addSecondaryDeviceModal = false;
        });
    },
    async fetchSageTaxTypes() {
      await Api()
        .get("/sageOne/taxTypes")
        .then((res) => {
          this.taxTypes = res.data.Results;
        });
    },
    async viewInvoice(item) {
      await Api()
        .get("/sageOne/invoice/" + item.AllocatedToDocumentId)
        .then((res) => {
          this.invoiceItem = res.data;
          this.invoiceModal = true;
        });
    },
    backTicketArrow() {
      this.ticketIndex--;
      if (this.$vuetify.breakpoint.lgAndDown) {
        this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
      } else {
        this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
      }

      this.ticketKey++;
    },
    forwardTicketArrow() {
      this.ticketIndex++;
      if (this.$vuetify.breakpoint.lgAndDown) {
        this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
      } else {
        this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
      }

      this.ticketKey++;
    },
    saveAccessBuild() {
      Api()
        .put("/applications/" + this.applicationInfo.id, {
          additionalAccessBuildDocument: this.applicationInfo.additionalAccessBuildDocument,
          additionalAccessBuildFeeExclVat: this.applicationInfo.additionalAccessBuildFeeExclVat,
        })
        .then((response) => {
          this.getApplication();
        });
    },
    async selectFile(event) {
      await this.uploadFile(event.srcElement.files[0]);
    },
    async uploadFile(file) {
      var reader = await new FileReader();
      await reader.readAsDataURL(file);
      reader.onload = () => {
        this.setResult(reader.result);
      };
      reader.onerror = function() {
        console.log("there are some problems");
      };
    },
    setResult(result) {
      this.applicationInfo.additionalAccessBuildDocument = result;
      this.keyAdditionalAccessBuildDocument += 1;
    },
    async routeToTicketSummary(item) {
      let url = item;
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
        return el.url === "/ticketSummary/:ticketId";
      });
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({ path: "/ticketSummary/" + item });
    },
    addComment(comment) {
      this.ticketCommentLog.push({
        commentedBy: this.$store.state.user,
        commentedById: this.$store.state.user.id,
        comment: comment,
        type: "comment",
        createdAt: new Date(),
      });
      this.comment = "";
      this.addCommentBox = false;
    },
    removeContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/LocationContact/" + item.id, {
            isDeleted: true,
            isActive: false,
          })
          .then((response) => {
            (item.isActive = false), (item.isDeleted = true);
          });
        let index = this.locationContacts.indexOf(item);
        this.locationContacts.splice(index, 1);
        if (!this.locationContacts.length > 0) {
          this.showApplicationContacts = true;
          this.showLocationContacts = false;
        }
      }
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    processPortChange() {
      if (this.provisionTemplate != null) {
        if (this.changedPort) {
          this.provisionTemplate.tpIndex = this.changedPort;
        }
        let ponId = this.device.gponOnuId.toString();
        if (this.provisionTemplate.gponOnuId < 10) {
          ponId = "0" + ponId;
        }

        if (!this.provisionTemplate.autoSelectGemPortValue) {
          this.provisionTemplate.gponPortId = "3" + this.provisionTemplate.tpIndex.toString() + ponId;
        } else {
          this.provisionTemplate.gponPortId = 0;
        }
        this.changedPort = null;
        this.provisionWarningModal = false;
        this.approveApplication();
      }
    },
    prepareZhoneTemplate() {
      if (this.provisionTemplate != null) {
        this.provisionTemplate.Device_ID = this.device.Device_ID;
        this.provisionTemplate.Handle_ID = this.device.Handle_ID;
        this.provisionTemplate.gponSlotId = this.device.gponSlotId;
        this.provisionTemplate.gponOltId = this.device.gponOltId;
        this.provisionTemplate.gponPortId = this.device.gponPortId;

        this.provisionTemplate.gponOnuId = this.device.gponOnuId;
        if (this.changedPort) {
          this.provisionTemplate.tpIndex = this.changedPort;
        }
        let ponId = this.device.gponOnuId.toString();
        if (this.provisionTemplate.gponOnuId < 10) {
          ponId = "0" + ponId;
        }

        if (!this.provisionTemplate.autoSelectGemPortValue) {
          this.provisionTemplate.gponPortId = "3" + this.provisionTemplate.tpIndex.toString() + ponId;
        } else {
          this.provisionTemplate.gponPortId = 0;
        }
      }
    },
    filterByValue(array, string) {
      return array.filter((o) => {
        return Object.keys(o).some((k) => {
          if (typeof o[k] === "string") return o[k].toLowerCase().includes(string.toLowerCase());
        });
      });
    },
    async fetchXeroContacts() {
      await Api()
        .get("/xero/allContacts")
        .then((response) => {
          this.xeroContacts = response.data;
        });
    },
    async findSimilarContacts(contact, name, email) {
      let similarContacts = [];
      let similarNames = await this.filterByValue(this.xeroContacts, name);
      for (let a = 0; a < similarNames.length; a++) {
        let match = (await Math.round(this.similarity(name, similarNames[a].Name) * 10000)) / 100;
        await similarContacts.push({
          xeroContactId: similarNames[a].ContactID,
          match: match,
          name: similarNames[a].Name,
          email: similarNames[a].EmailAddress,
        });
      }
      this.similarXeroContacts = similarContacts;
      if (this.similarXeroContacts.length > 0) {
        this.xeroContactsModal = true;
      } else {
        this.xeroContactsModal = false;
        confirm(
          "Are you sure you would like to generate the invoice for " + contact.name + " " + contact.surname + "?"
        ) && this.generateXeroInvoice(contact);
      }
    },

    createXeroContact() {
      let contact = null;
      let taxNumber = null;
      if (this.applicationInfo.billingContactId !== null) {
        contact = this.applicationInfo.billingContact;
      } else if (this.applicationInfo.primaryContactId !== null) {
        contact = this.applicationInfo.primaryContact;
      }
      if (this.applicationInfo.billingContactId !== null && this.applicationInfo.billingContactVatNumber !== null) {
        taxNumber = null;
      } else {
        taxNumber = this.applicationInfo.billingContactVatNumber;
      }
      Api()
        .post("/xero/contact", {
          Name: contact.name + " " + contact.surname,
          FirstName: contact.name,
          LastName: contact.surname,
          EmailAddress: contact.emailAddress,
          ContactStatus: "ACTIVE",
          ContactID:
            this.makeContactId(8).toString() +
            "-" +
            this.makeContactId(4).toString() +
            "-" +
            this.makeContactId(4).toString() +
            "-" +
            this.makeContactId(4).toString() +
            "-" +
            this.makeContactId(8).toString(),
          //  00000000-0000-0000-0000-000000000000
          TaxNumber: this.applicationInfo.billingContactVatNumber,
          Addresses: [
            {
              AddressLine1: this.applicationInfo.location.locationDescription,
              AddressLine2: this.applicationInfo.location.locationNetwork.streetName,
              AddressLine3: this.applicationInfo.location.locationNetwork.suburb,
              AddressLine3: this.applicationInfo.location.locationNetwork.town,
              City: this.applicationInfo.location.locationNetwork.city,
              Country: this.applicationInfo.location.locationNetwork.country,
            },
          ],
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    makeContactId(length) {
      var result = "";
      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    similarity(s1, s2) {
      var longer = s1;
      var shorter = s2;
      if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
      }
      var longerLength = longer.length;
      if (longerLength == 0) {
        return 1.0;
      }
      return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
    },
    editDistance(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();

      var costs = new Array();
      for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
          if (i == 0) costs[j] = j;
          else {
            if (j > 0) {
              var newValue = costs[j - 1];
              if (s1.charAt(i - 1) != s2.charAt(j - 1))
                newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
              costs[j - 1] = lastValue;
              lastValue = newValue;
            }
          }
        }
        if (i > 0) costs[s2.length] = lastValue;
      }
      return costs[s2.length];
    },
    fetchDocuments() {
      Api()
        .get("/upload/byApplication/" + this.applicationInfo.id)
        .then((res) => {
          this.documents = res.data;
        });
    },
    fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async (response) => {
          this.filteredUsers = response.data.filter(function(el) {
            return el.userType !== "endClient";
          });
          let contactArray = await this.filteredUsers.map((x) => x.contact);
          this.members = await contactArray.map((x) => x.name + " " + x.surname);
          await contactArray.map((x) => {
            this.membersEmail.push({
              fullName: x.name + " " + x.surname,
              email: x.emailAddress,
            });
          });
          this.filteredUsers = contactArray;
        });
    },
    fetchProducts() {
      Api()
        .get("/applicationLocationNetworkProduct/byApplication/" + this.$route.params.applicationId)
        .then((response) => {
          this.products = response.data;
        });
    },
    async initialize() {
      await this.getApplication();
      this.fetchApplicationComments();
      this.fetchProducts();
      this.fetchLocationNetworks();
      this.getExistingServiceAccounts();
      this.fetchTickets();
      this.fetchAllVlans();
      this.fetchOrgContacts();
      this.getlocationTypes();
      this.fetchUserRoles();
      this.fetchTicketCategories();
      this.fetchTicketCategoryItems();
      this.fetchDocuments();
      if (this.device) {
        this.fetchDeviceBridges(this.device.id);
        this.getAvailableTemplates(this.device.deviceMakeModel.deviceMakeId);
      }
      this.fetchFeasibilitytests();
      if (
        this.applicationInfo.packagesIsp &&
        this.applicationInfo.packagesIsp.datatillProductId &&
        this.applicationInfo.packagesIsp.customerOrganisationId == this.applicationInfo.supplierOrganisationId
      ) {
        this.checkDatatillIntegration();
      }
      if (this.$store.state.currentOrg.org.accountingSystem == "SageOne" && this.applicationInfo.accountingCustomerId) {
        this.fetchSageCustomerDetails(this.applicationInfo.accountingCustomerId);
        this.fetchTransactions(this.applicationInfo.accountingCustomerId);
        this.fetchSageTaxTypes();
      }
    },
    fetchApplicationComments() {
      this.commentArray = [];
      Api()
        .get("/applicationComment/byApplication/" + this.$route.params.applicationId)
        .then(async (response) => {
          await response.data.map((x) => {
            this.commentArray.push({
              commentedById: x.commentedById,
              commentedByName: x.commentedBy.name,
              commentedBySurname: x.commentedBy.surname,
              comment: x.comment,
              type: x.type,
              createdAt: x.createdAt,
              id: x.id,
              commentLogType: true,
            });
          });
          this.commentArray.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        });
    },
    async fetchTransactions(id) {
      await Api()
        .get("/sageOne/customer/transactions/" + id)
        .then((res) => {
          if (res.data.length > 0) {
            this.transactions = res.data;
            this.invoices = res.data;
          }
        });
    },
    fetchSageCustomerDetails(customerId) {
      Api()
        .get("/sageOne/ageAnalysisSummary/" + customerId)
        .then((res) => {
          this.ageAnalysis = res.data;
        });
    },
    createSageRecurringInvoice() {
      let today = new Date();
      today.setDate(1);
      today.setMonth(today.getMonth() + 1);
      let obj = {
        CustomerId: parseInt(this.applicationInfo.accountingCustomerId),
        Schedule: {
          StartDate: [
            today.getFullYear(),
            today.getMonth() + 1 < 10 ? "0" + (today.getMonth() + 1).toString() : today.getMonth() + 1,
            today.getDate() < 10 ? "0" + today.getDate().toString() : today.getDate(),
          ].join("-"),
          ScheduleFrequencyId: 5,
          Active: true,
        },
        RecurringProfile: {
          AutoCreate: true,
          DueDateMethodId: 0,
          DueDateMethodValue: 7,
        },
        Date: [
          today.getFullYear(),
          today.getMonth() + 1 < 10 ? "0" + (today.getMonth() + 1).toString() : today.getMonth() + 1,
          today.getDate() < 10 ? "0" + today.getDate().toString() : today.getDate(),
        ].join("-"),
        DueDateMethodId: 1,
        DueDateMethodValue: 1,
        ExternalReference: this.applicationInfo.id,
        Lines: [
          {
            SelectionId: parseInt(this.applicationInfo.packagesIsp.accountCode),
            LineType: 1,
            TaxTypeId: 123125,
            UnitPriceExclusive: this.applicationInfo.ispRecurringPriceVatInc / (1 + $VAT),
            Quantity: 1,
          },
        ],
      };
      Api()
        .post("/sageOne/createRecurringInvoice", obj)
        .then(async (res) => {
          if (res.data.ID) {
            await Api().put("/applications/" + this.applicationInfo.id, {
              recurringInvoiceId: res.data.ID,
              recurringInvoiceNumber: res.data.DocumentNumber,
            });
            this.applicationInfo.recurringInvoiceId = res.data.ID;
            this.applicationInfo.recurringInvoiceNumber = res.data.DocumentNumber;
          }
        });
    },
    checkDatatillIntegration() {
      Api()
        .get("/integrations/byName/Datatill")
        .then((response) => {
          if (response.data) {
            this.datatillIntegration = true;
            this.fetchDatatillCustomer();
          }
        });
    },
    async getAvailableTemplates(deviceMakeId) {
      Api()
        .get(
          "/customer/organisationBridgeTemplate/byCustomerDeviceMake/" +
            deviceMakeId +
            "/" +
            this.$store.state.currentOrg.org.id
        )
        .then((response) => {
          this.bridgeTemplates = response.data;
        });
    },
    fetchDatatillCustomer() {
      this.datatillContactType = "Primary";
      this.datatillContactTypeList = [];
      if (this.applicationInfo.primaryContactEmailAddress) {
        this.datatillContactTypeList.push("Primary");
      }
      if (this.applicationInfo.secondaryContactEmailAddress) {
        this.datatillContactTypeList.push("Secondary");
      }
      if (this.applicationInfo.billingContactEmailAddress) {
        this.datatillContactTypeList.push("Billing");
      }
      Api()
        .post("/datatill/customerList", {
          organisationId: this.$store.state.currentOrg.org.id,
          primaryContactEmail: this.applicationInfo.primaryContactEmailAddress,
          secondaryContactEmail: this.applicationInfo.secondaryContactEmailAddress,
          billingContactEmail: this.applicationInfo.billingContactEmailAddress,
          // contactEmail: 'cornelis.vanrensburg@gmail.com'
        })
        .then((response) => {
          this.allCustomers = response.data.allCustomers;
          this.foundExisting = [];
          if (response.data.primaryCustomerId !== null) {
            this.foundExisting.push({
              type: "Primary",
              customerId: response.data.primaryCustomerId,
              fullName:
                this.applicationInfo.primaryContactFirstname + " " + this.applicationInfo.primaryContactLastname,
              email: this.applicationInfo.primaryContactEmailAddress,
              mobile: this.applicationInfo.primaryContactMobileNumber,
              idNumber: this.applicationInfo.primaryContactIdNumber,
            });
            // this.applicationInfo.datatillCustomerId = response.data.customerId
            // this.existingDatatillCustomer = true
          }
          if (response.data.secondaryCustomerId !== null) {
            this.foundExisting.push({
              type: "Secondary",
              customerId: response.data.secondaryCustomerId,
              fullName:
                this.applicationInfo.secondaryContactFirstname + " " + this.applicationInfo.secondaryContactLastname,
              email: this.applicationInfo.secondaryContactEmailAddress,
              mobile: this.applicationInfo.secondaryContactMobileNumber,
              idNumber: this.applicationInfo.secondaryContactIdNumber,
            });
            // this.existingDatatillCustomer = true
          }
          if (response.data.billingCustomerId !== null) {
            this.foundExisting.push({
              type: "Billing",
              customerId: response.data.billingCustomerId,
              fullName:
                this.applicationInfo.billingContactFirstname + " " + this.applicationInfo.billingContactLastname,
              email: this.applicationInfo.billingContactEmailAddress,
              mobile: this.applicationInfo.billingContactMobileNumber,
              idNumber: this.applicationInfo.billingContactIdNumber,
            });
            // this.existingDatatillCustomer = true
          }
        });
    },
    ispVerifyModal() {
      if (this.bridgeTemplates.length == 0) {
        confirm(
          "You do not have any configuration templates for this make. Please set this up with the relevant Fibre Network Operator."
        );
      } else {
        if (this.device) {
          let selectedTemplates = [];
          if (this.device.deviceMakeModel.oneDevicePolicy && this.device.deviceMakeModel.twoDevicePolicy) {
            selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice" || x.type == "TwoDevice");
          } else if (this.device.deviceMakeModel.oneDevicePolicy && !this.device.deviceMakeModel.twoDevicePolicy) {
            selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice");
          } else if (!this.device.deviceMakeModel.oneDevicePolicy && this.device.deviceMakeModel.twoDevicePolicy) {
            selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "TwoDevice");
          }
          if (selectedTemplates.length == 0) {
            confirm(
              "You do not have any configuration templates that match the available policies for this device model. Please contact the Fibre Network Operator to rectify this issue."
            );
          } else {
            if (selectedTemplates.length > 0) {
              this.configurationSettings = {
                type: "Multiple",
                bridgeTemplates: selectedTemplates,
                selectedTemplateId: selectedTemplates[0].id,
                connectionType: selectedTemplates[0].connectionType,
              };
              if (selectedTemplates.length > 1 || this.configurationSettings.connectionType.toLowerCase() == "pppoe") {
                this.configModal = true;
              } else {
                this.submitConfiguration();
              }
            }
          }
        }
      }
    },
    generatePassword() {
      let result = "";
      let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 12; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    async submitConfiguration() {
      if (
        this.configurationSettings.connectionType.toLowerCase() == "pppoe" &&
        !this.configurationSettings.pppoePassword
      ) {
        this.configurationSettings.pppoePassword = this.generatePassword();
      }
      this.provisionTemplate = this.configurationSettings.bridgeTemplates.find(
        (x) => x.id == this.configurationSettings.selectedTemplateId
      );
      this.applicationInfo.pppoeUsername = this.configurationSettings.pppoeUsername;
      this.applicationInfo.pppoePassword = this.configurationSettings.pppoePassword;

      await Api()
        .put("/customer/applications/" + this.$route.params.applicationId, {
          ispVerified: true,
          ispVerifiedById: this.$store.state.user.id,
          ispVerifiedDate: new Date(),
          ispAccepted: true,
          organisationBridgeTemplateId: this.configurationSettings.selectedTemplateId,
          serviceAccountType: this.configurationSettings.connectionType,
          pppoeUsername: this.configurationSettings.pppoeUsername,
          pppoePassword: this.configurationSettings.pppoePassword,
        })
        .then(async (response) => {
          if (this.datatillIntegration) {
            if (this.existingDatatillCustomer === true) {
              Api().put("/customer/applications/" + this.$route.params.applicationId, {
                datatillCustomerId: this.selectedExistingCustomer.customerId,
              });
            } else {
              if (this.createNewDatatillCustomer) {
                await Api()
                  .post("/datatill/addCustomer", {
                    organisationId: this.$store.state.currentOrg.org.id,
                    idNumber: this.newCustomer.idNumber,
                    name: this.newCustomer.fullName,
                    telephoneNumber: this.newCustomer.telephoneNumber,
                    mobileNumber: this.newCustomer.mobileNumber,
                    emailAddress: this.newCustomer.emailAddress,
                    physicalAddress: this.applicationInfo.location.locationDescription,
                    postalAddress: this.applicationInfo.location.locationDescription,
                  })
                  .then(async (response) => {
                    await Api().put("/customer/applications/" + this.$route.params.applicationId, {
                      datatillCustomerId: response.data.customerId,
                    });
                  });
              } else {
                await Api().put("/customer/applications/" + this.$route.params.applicationId, {
                  datatillCustomerId: this.applicationInfo.datatillCustomerId,
                });
              }
            }
          }
        });
      this.configModal = false;
      (this.applicationInfo.ispVerified = true),
        (this.applicationInfo.ispAccepted = true),
        (this.applicationInfo.ispVerifiedDate = new Date()),
        (this.applicationInfo.ispVerifiedById = this.$store.state.user.id),
        (this.applicationInfo.ispVerifiedBy = this.$store.state.user);

      // await this.getApplication()
      this.approveApplication();
    },
    fetchFeasibilitytests() {
      Api()
        .get("/gis/feasibilityTest/application/" + this.$route.params.applicationId)
        .then((res) => {
          let center = this.applicationInfo.coordinates;
          if (center) {
            this.center = {
              lat: parseFloat(center.lat),
              lng: parseFloat(center.lng),
            };
          }

          this.feasibilityTests = res.data;
          let findSuccess = this.feasibilityTests.find((x) => x.success);
          if (findSuccess) {
            this.lineChartData = findSuccess;
          }
        });
    },
    getlocationTypes() {
      Api()
        .get("/locationTypes")
        .then((response) => {
          this.locationTypes = response.data;
        });
    },
    fetchUserRoles() {
      Api()
        .get("/userRole")
        .then((response) => {
          this.userRoles = response.data;
        });
    },

    fetchLocationNetworks() {
      Api()
        .get("/locationnetworks/basic/active")
        .then((response) => {
          this.locationNetworks = response.data;
        });
    },

    fetchDeviceBridges(id) {
      Api()
        .get("/deviceBridge/" + id)
        .then((response) => {
          this.deviceBridges = response.data;
        });
    },
    fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then((response) => {
          this.ticketCategories = response.data;
        });
    },
    fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then((response) => {
          this.ticketCategoryItems = response.data;
          this.ticketKey += 1;
        });
    },
    addCommentEditedTicket(comment) {
      Api()
        .post("/ticketComment", {
          ticketId: this.ticketItem.id,
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          response.data.commentedBy = this.$store.state.user;
          this.ticketCommentLog.push(response.data);
          this.comment = "";
          this.addCommentBox = false;
        });
    },
    async addApplicationComment(comment) {
      this.emailAddressArray = [];
      this.mentioned = this.members.filter((x) => comment.includes(x));
      await this.mentioned.map((y) => {
        this.membersEmail.map((x) => {
          if (x.fullName === y) {
            this.emailAddressArray.push(x.email);
          }
        });
      });
      comment = comment.replace(/<div>/g, "");
      comment = comment.replace("</div>", "");
      comment = comment.replace(/<br>/g, "");
      Api()
        .post("/applicationComment", {
          emailAddressArray: this.emailAddressArray,
          isInternal: this.internal,
          organisation: this.$store.state.currentOrg.org,
          applicationId: parseInt(this.$route.params.applicationId),
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          if (this.internal == false) {
            this.notifyIsp();
            this.notifyFno();
          } else {
            this.notifyFno();
          }
          this.fetchApplicationComments();
          this.comment = "";
        });
    },
    async fetchTickets() {
      await Api()
        .get("/ticket/byApplication/" + this.$route.params.applicationId)
        .then((response) => {
          this.tickets = response.data;
          let temp = response.data;
          this.ticketCarousalArray = temp.slice(0, 1);
          this.ticketKey += 1;
        });
    },
    // async getAvailableTemplates(customerOrganisationId, deviceMakeId) {
    //   Api()
    //     .get(
    //       "/organisationBridgeTemplate/byCustomerDeviceMake/" +
    //         customerOrganisationId +
    //         "/" +
    //         deviceMakeId
    //     )
    //     .then((response) => {
    //       if (response.data != "") {
    //         this.provisionTemplate = response.data;

    //         if (this.provisionTemplate != null) {
    //           this.provisionTemplate.uploadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.uploadMbps;
    //           this.provisionTemplate.downloadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.downloadMbps;
    //           this.provisionTemplate.Device_ID = this.device.Device_ID;
    //           this.provisionTemplate.gponSlotId = this.device.gponSlotId;
    //           this.provisionTemplate.gponOltId = this.device.gponOltId;
    //           this.provisionTemplate.gponOnuId = this.device.gponOnuId;
    //           this.provisionTemplate.deviceId = this.device.id;

    //           let ponId = this.device.gponOnuId.toString();
    //           if (this.device.gponOnuId < 10) {
    //             ponId = "0" + ponId;
    //           }

    //           if (!this.provisionTemplate.autoSelectGemPortValue) {
    //             this.provisionTemplate.gponPortId =
    //               "3" + this.provisionTemplate.tpIndex.toString() + ponId;
    //           } else {
    //             this.provisionTemplate.gponPortId = 0;
    //           }
    //         }
    //       }
    //     });
    // },
    checkDenyPermissions() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.deniedReasonModal = true;
      }
    },
    async createInvoiceItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        if (this.applicationInfo.billingContactId === null && this.applicationInfo.primaryContactId === null) {
          confirm("Please first create either the primary or billing contact.");
        } else {
          let contact = null;
          if (this.applicationInfo.billingContactId !== null) {
            contact = this.applicationInfo.billingContact;
            await this.findSimilarContacts(
              contact,
              this.applicationInfo.billingContact.name + " " + this.applicationInfo.billingContact.surname,
              this.applicationInfo.billingContact.emailAddress
            );
          } else {
            contact = this.applicationInfo.primaryContact;
            await this.findSimilarContacts(
              contact,
              this.applicationInfo.primaryContact.name + " " + this.applicationInfo.primaryContact.surname,
              this.applicationInfo.primaryContact.emailAddress
            );
          }
        }
      }
    },
    provisionAccount() {
      return true;
      // if (
      //   this.provisionTemplate != null &&
      //   this.device &&
      //   this.device.deviceMakeModel.deviceMake.name.toLowerCase() == "zhone" &&
      //   this.deviceBridges.length > 0 &&
      //   this.deviceBridges
      //     .map((x) => x.tpIndex)
      //     .includes(
      //       parseInt(this.applicationInfo.organisationBridgeTemplate.tpIndex)
      //     )
      // ) {
      //   return false;
      // } else {
      //   return true;
      // }
    },
    attachExisting(id) {
      Api()
        .put("customer/applications/" + this.$route.params.applicationId, {
          locationId: id,
        })
        .then((response) => {
          this.attachLocationModal = false;
          this.getApplication();
        });
    },
    createNewLocation() {
      Api()
        .get("/locationNetworks/" + this.applicationInfo.locationNetworkId)
        .then((response) => {
          Api()
            .post("/locations", {
              locationDescription:
                this.applicationInfo.streetNumber + " " + this.applicationInfo.streetName + ", " + response.data.name,
              unitNo: this.applicationInfo.streetNumber,
              complexStreetName: this.applicationInfo.streetName,
              locationNetworkId: this.applicationInfo.locationNetworkId,

              locationTypeId: this.applicationInfo.locationTypeId,
              erfNo: this.applicationInfo.erfNo,
              otherNo: this.applicationInfo.otherNo,
              locationNetworkSubComplexId: this.applicationInfo.locationNetworkSubComplexId,
              floorNo: this.applicationInfo.floorNo,
              subComplexName: this.applicationInfo.subComplexName,
              complexName: this.applicationInfo.complexName,
              coordinates: this.applicationInfo.coordinates ? JSON.stringify(this.applicationInfo.coordinates) : null,
            })
            .then((response) => {
              Api()
                .put("customer/applications/" + this.$route.params.applicationId, {
                  locationId: response.data.id,
                })
                .then((response) => {
                  this.getApplication();
                  this.attachLocationModal = false;
                });
            });
        });
    },
    async generateXeroInvoice() {
      // await this.createXeroContact()
      let contact = null;
      let taxNumber = null;
      let lineItems = [];
      if (this.applicationInfo.billingContactId !== null) {
        contact = this.applicationInfo.billingContact;
      } else if (this.applicationInfo.primaryContactId !== null) {
        contact = this.applicationInfo.primaryContact;
      }
      if (this.applicationInfo.billingVatNumber !== null) {
        taxNumber = this.applicationInfo.billingVatNumber;
      }
      if (this.applicationInfo.routerInstallationFee > 0) {
        await lineItems.push({
          Description: "FTTH Installation Fee",
          AccountCode: "INS",
          Quantity: 1,
          UnitAmount: this.applicationInfo.routerInstallationFee,
        });
      }
      if (this.applicationInfo.gtuInstallationFee > 0) {
        await lineItems.push({
          Description: "GTU Installation Fee",
          AccountCode: "211",
          Quantity: 1,
          UnitAmount: this.applicationInfo.gtuInstallationFee,
        });
      }
      let date = new Date();
      Api()
        .post("/xero/invoice", {
          Type: "ACCREC",
          Contact: {
            Name: contact.name + " " + contact.surname,
            FirstName: contact.name,
            LastName: contact.surname,
            EmailAddress: contact.emailAddress,
            // EmailAddress: 'jarryd@dotparse.com',
            ContactStatus: "ACTIVE",
            TaxNumber: taxNumber,
            Addresses: [
              {
                AddressLine1: this.applicationInfo.location.locationDescription,
                AddressLine2: this.applicationInfo.location.locationNetwork.streetName,
                AddressLine3: this.applicationInfo.location.locationNetwork.suburb,
                AddressLine3: this.applicationInfo.location.locationNetwork.town,
                City: this.applicationInfo.location.locationNetwork.city,
                Country: this.applicationInfo.location.locationNetwork.country,
              },
            ],
          },
          Reference: "FTTH Installation",
          Date: date,
          DueDate: date,
          LineAmountTypes: "Inclusive",
          LineItems: lineItems,
        })
        .then(async (response) => {
          if (response.status === 200) {
            this.snackbar = true;
            this.text = "Invoice successfully created!";
          }
          this.applicationInfo.invoiceNumber = response.data[0].invoiceNumber;
          this.applicationInfo.isInvoiced = true;
          await Api().put("/applications/" + this.applicationInfo.id, {
            isInvoiced: true,
            invoiceNumber: response.data[0].InvoiceNumber,
          });
          // await Api()
          // .post('/xero/emailInvoice',{
          //   InvoiceID: response.data[0].InvoiceID
          // }).then(response=>{
          //     this.snackbar=true
          //     this.text="Invoice successfully sent via email!"
          // })
          let transactionPost = [];
          if (this.applicationInfo.routerInstallationFee > 0) {
            await transactionPost.push({
              date: new Date(),
              description: "Router Installation",
              xeroCode: "1",
              amount: this.applicationInfo.routerInstallationFee / (1 + $VAT),
              isRecurring: false,
              transactionType: "Sales",
              locationId: this.applicationInfo.locationId,
              locationNetworkId: this.applicationInfo.location.locationNetworkId,
              locationNodeId: this.applicationInfo.location.locationNetwork.locationNodeId,
              isActive: true,
              isDeleted: false,
            });
          }
          if (this.applicationInfo.hasTvOverFibre && this.applicationInfo.gtuInstallationFee > 0) {
            await transactionPost.push({
              date: new Date(),
              description: "GTU Installation",
              xeroCode: "1",
              amount: this.applicationInfo.gtuInstallationFee / (1 + $VAT),
              isRecurring: false,
              transactionType: "Sales",
              locationId: this.applicationInfo.locationId,
              locationNetworkId: this.applicationInfo.location.locationNetworkId,
              locationNodeId: this.applicationInfo.location.locationNetwork.locationNodeId,
              isActive: true,
              isDeleted: false,
            });
          }
          await Api().post("/transactions/bulk", {
            batch: transactionPost,
          });
          this.initialize();
        });
    },
    verifyInstallation() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.verifyingInstallation = true;
        Api()
          .put("/applications/" + this.$route.params.applicationId, {
            isInstallVerified: true,
            installVerifiedById: this.$store.state.user.id,
            installVerifiedDate: new Date(),
          })
          .then((response) => {
            this.verifyingInstallation = false;
            this.applicationInfo.isInstallVerified = true;
            this.notifyIsp();
          });
      }
    },
    verifyDevice() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.verifyingDevice = true;
        Api()
          .put("/applications/" + this.$route.params.applicationId, {
            isDeviceVerified: true,
            deviceVerifiedById: this.$store.state.user.id,
            deviceVerifiedDate: new Date(),
          })
          .then((response) => {
            this.verifyingDevice = false;
            this.applicationInfo.isDeviceVerified = true;
          });
      }
    },
    generatePassiveInstall() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to create the passive installation for this location?") &&
          Api()
            .post("/installations", {
              patchLead: true,
              ftthBox: true,
              labelling: true,
              mstConnection: true,
              locationId: this.applicationInfo.locationId,
              timeStamp: new Date(),
              isPassiveInstall: true,
              passiveInstallComplete: true,
              isDeleted: false,
              isActive: true,
            })
            .then((response) => {
              Api()
                .put("/locations/" + this.applicationInfo.locationId, {
                  fibrePulled: true,
                })
                .then((response) => {
                  this.applicationInfo.location.fibrePulled = true;
                });
            });
      }
    },
    changeInvoiceStatus() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (!this.applicationInfo.isInvoiced) {
          this.invoiceNumberDialog = true;
        } else {
          this.saveInvoiceStatus();
        }
      }
    },
    saveInvoiceStatus() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to change the invoiced status?") &&
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              isInvoiced: !this.applicationInfo.isInvoiced,
            })
            .then((response) => {
              if (response.data.isInvoiced === false) {
                this.applicationInfo.invoiceNumber = "";
                Api().put("/applications/" + this.$route.params.applicationId, {
                  invoiceNumber: this.applicationInfo.invoiceNumber,
                });
              }
              this.applicationInfo.isInvoiced = !this.applicationInfo.isInvoiced;
              this.invoiceNumberDialog = false;
            });
      }
    },
    async changePaidStatus() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to change the paid status? WARNING: This step is not reversible.") &&
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              isPaid: true,
            })
            .then(async (response) => {
              this.applicationInfo.isPaid = true;
              let transactionPost = [];
              if (this.applicationInfo.routerInstallationFee > 0) {
                await transactionPost.push({
                  date: new Date(),
                  description: "Router Installation",
                  xeroCode: "1",
                  amount: this.applicationInfo.routerInstallationFee / (1 + $VAT),
                  isRecurring: false,
                  transactionType: "Sales",
                  locationId: this.applicationInfo.locationId,
                  locationNetworkId: this.applicationInfo.location.locationNetworkId,
                  locationNodeId: this.applicationInfo.location.locationNetwork.locationNodeId,
                  isActive: true,
                  isDeleted: false,
                });
              }
              if (this.applicationInfo.hasTvOverFibre && this.applicationInfo.gtuInstallationFee > 0) {
                await transactionPost.push({
                  date: new Date(),
                  description: "GTU Installation",
                  xeroCode: "1",
                  amount: this.applicationInfo.gtuInstallationFee / (1 + $VAT),
                  isRecurring: false,
                  transactionType: "Sales",
                  locationId: this.applicationInfo.locationId,
                  locationNetworkId: this.applicationInfo.location.locationNetworkId,
                  locationNodeId: this.applicationInfo.location.locationNetwork.locationNodeId,
                  isActive: true,
                  isDeleted: false,
                });
              }
              await Api().post("/transactions/bulk", {
                batch: transactionPost,
              });
            });
      }
    },
    verifyPackage() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/applications/" + this.$route.params.applicationId, {
            isPackageVerified: true,
            packageVerifiedById: this.$store.state.user.id,
            packageVerifiedDate: new Date(),
          })
          .then((response) => {
            this.applicationInfo.isPackageVerified = true;
            this.notifyIsp();
          });
      }
    },
    fetchAllDevices() {
      Api()
        .get("/devices")
        .then((response) => {
          this.allDevices = response.data;
        });
    },
    editContact(contactType) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (contactType === "Primary") {
          this.editedContact.contactType = "Primary";
          this.editedContact.name = this.applicationInfo.primaryContactFirstname;
          this.editedContact.surname = this.applicationInfo.primaryContactLastname;
          this.editedContact.idNumber = this.applicationInfo.primaryContactIdNumber;
          this.editedContact.emailAddress = this.applicationInfo.primaryContactEmailAddress;
          this.editedContact.mobileNumber = this.applicationInfo.primaryContactMobileNumber;
        }
        if (contactType === "Secondary") {
          this.editedContact.contactType = "Secondary";
          this.editedContact.name = this.applicationInfo.secondaryContactFirstname;
          this.editedContact.surname = this.applicationInfo.secondaryContactLastname;
          this.editedContact.idNumber = this.applicationInfo.secondaryContactIdNumber;
          this.editedContact.emailAddress = this.applicationInfo.secondaryContactEmailAddress;
          this.editedContact.mobileNumber = this.applicationInfo.secondaryContactMobileNumber;
        }
        if (contactType === "Billing") {
          this.editedContact.contactType = "Billing";
          this.editedContact.name = this.applicationInfo.billingContactFirstname;
          this.editedContact.surname = this.applicationInfo.billingContactLastname;
          this.editedContact.idNumber = this.applicationInfo.billingContactIdNumber;
          this.editedContact.emailAddress = this.applicationInfo.billingContactEmailAddress;
          this.editedContact.mobileNumber = this.applicationInfo.billingContactMobileNumber;
        }
        this.editContactModal = true;
      }
    },
    saveEditedContact() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (this.editedContact.contactType === "Primary") {
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              primaryContactFirstname: this.editedContact.name,
              primaryContactLastname: this.editedContact.surname,
              primaryContactMobileNumber: this.editedContact.mobileNumber,
              primaryContactEmailAddress: this.editedContact.emailAddress,
              primaryContactIdNumber: this.editedContact.idNumber,
            })
            .then((response) => {
              this.initialize();
              this.editContactModal = false;
              this.editedContact = {};
            });
        }
        if (this.editedContact.contactType === "Secondary") {
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              secondaryContactFirstname: this.editedContact.name,
              secondaryContactLastname: this.editedContact.surname,
              secondaryContactMobileNumber: this.editedContact.mobileNumber,
              secondaryContactEmailAddress: this.editedContact.emailAddress,
              secondaryContactIdNumber: this.editedContact.idNumber,
            })
            .then((response) => {
              this.editContactModal = false;
              this.editedContact = {};
              this.initialize();
            });
        }
        if (this.editedContact.contactType === "Billing") {
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              billingContactFirstname: this.editedContact.name,
              billingContactLastname: this.editedContact.surname,
              billingContactMobileNumber: this.editedContact.mobileNumber,
              billingContactEmailAddress: this.editedContact.emailAddress,
              billingContactIdNumber: this.editedContact.idNumber,
            })
            .then((response) => {
              this.editContactModal = false;
              this.editedContact = {};
              this.initialize();
            });
        }
      }
    },
    async goToLocation() {
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
        return el.url === "/locationNetworks/:locationNetworkId/:locationId";
      });

      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({
        path:
          "/locationNetworks/" +
          this.applicationInfo.location.locationNetworkId +
          "/" +
          this.applicationInfo.locationId,
      });
    },
    async goToDevice(id) {
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
        return el.url === "/devices/:deviceId";
      });

      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.$router.push({
        path: "/devices/" + id,
      });
    },
    redirectToServiceAccount(id) {
      this.$router.push({
        path: "/serviceAccounts/" + id,
      });
    },
    addContact(contactType) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let name = null;
        let surname = null;
        let idNumber = null;
        let mobileNumber = null;
        let emailAddress = null;
        let password = "P@ssw0rd1234";
        let permissions = "End Client";
        let isActive = true;
        if (contactType === "Primary") {
          this.creatingPrimaryContact = true;
          name = this.applicationInfo.primaryContactFirstname;
          surname = this.applicationInfo.primaryContactLastname;
          idNumber = this.applicationInfo.primaryContactIdNumber;
          emailAddress = this.applicationInfo.primaryContactEmailAddress;
          mobileNumber = this.applicationInfo.primaryContactMobileNumber;
        }
        if (contactType === "Secondary") {
          this.creatingSecondaryContact = true;
          name = this.applicationInfo.secondaryContactFirstname;
          surname = this.applicationInfo.secondaryContactLastname;
          idNumber = this.applicationInfo.secondaryContactIdNumber;
          emailAddress = this.applicationInfo.secondaryContactEmailAddress;
          mobileNumber = this.applicationInfo.secondaryContactMobileNumber;
        }
        if (contactType === "Billing") {
          this.creatingBillingContact = true;
          name = this.applicationInfo.billingContactFirstname;
          surname = this.applicationInfo.billingContactLastname;
          idNumber = this.applicationInfo.billingContactIdNumber;
          emailAddress = this.applicationInfo.billingContactEmailAddress;
          mobileNumber = this.applicationInfo.billingContactMobileNumber;
        }
        Api()
          .post("/contacts", {
            name: name,
            surname: surname,
            idNumber: idNumber,
            mobileNumber: mobileNumber,
            emailAddress: emailAddress,
            password: password,
            permissions: permissions,
            isActive: isActive,
          })
          .then((response) => {
            if (contactType === "Primary") {
              this.creatingPrimaryContact = false;
              this.applicationInfo.primaryContact = response.data;
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  primaryContactId: response.data.id,
                })
                .then((this.applicationInfo.primaryContactId = response.data.id));
            } else if (contactType === "Secondary") {
              this.creatingSecondaryContact = false;
              this.applicationInfo.secondaryContact = response.data;
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  secondaryContactId: response.data.id,
                })
                .then((this.applicationInfo.secondaryContactId = response.data.id));
            } else if (contactType === "Billing") {
              this.creatingBillingContact = false;
              this.applicationInfo.billingContact = response.data;
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  billingContactId: response.data.id,
                })
                .then((this.applicationInfo.billingContactId = response.data.id));
            }
          });
      }
    },
    mergePrimaryContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to update the existing contact?") &&
          Api()
            .put("/contacts/" + item.id, {
              name: this.applicationInfo.primaryContactFirstname,
              surname: this.applicationInfo.primaryContactLastname,
              idNumber: this.applicationInfo.primaryContactIdNumber,
              mobileNumber: this.applicationInfo.primaryContactMobileNumber,
              emailAddress: this.applicationInfo.primaryContactEmailAddress,
            })
            .then((response) => {
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  primaryContactId: item.id,
                })
                .then((this.applicationInfo.primaryContactId = item.id));
            });
        this.similarContactsModalPrimary = false;
      }
    },
    mergeSecondaryContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to update the existing contact?") &&
          Api()
            .put("/contacts/" + item.id, {
              name: this.applicationInfo.secondaryContactFirstname,
              surname: this.applicationInfo.secondaryContactLastname,
              idNumber: this.applicationInfo.secondaryContactIdNumber,
              mobileNumber: this.applicationInfo.secondaryContactMobileNumber,
              emailAddress: this.applicationInfo.secondaryContactEmailAddress,
            })
            .then((response) => {
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  secondaryContactId: item.id,
                })
                .then((this.applicationInfo.secondaryContactId = item.id));
            });
        this.similarContactsModalSecondary = false;
      }
    },
    mergeBillingContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to update the existing contact?") &&
          Api()
            .put("/contacts/" + item.id, {
              name: this.applicationInfo.billingContactFirstname,
              surname: this.applicationInfo.billingContactLastname,
              idNumber: this.applicationInfo.billingContactIdNumber,
              mobileNumber: this.applicationInfo.billingContactMobileNumber,
              emailAddress: this.applicationInfo.billingContactEmailAddress,
            })
            .then((response) => {
              Api()
                .put("/applications/" + this.applicationInfo.id, {
                  billingContactId: item.id,
                })
                .then((this.applicationInfo.billingContactId = item.id));
            });
        this.similarContactsModalBilling = false;
      }
    },
    verifyContact() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.verifyingContact = true;
        Api()
          .put("/applications/" + this.$route.params.applicationId, {
            isContactVerified: true,
            contactVerifiedById: this.$store.state.user.id,
            contactVerifiedDate: new Date(),
          })
          .then((response) => {
            this.applicationInfo.isContactVerified = true;
            this.verifyingContact = false;
            if(this.applicationInfo.packagesIsp)
              this.notifyIsp();
          });
      }
    },
    fetchAllVlans() {
      Api()
        .get("/vlans")
        .then((response) => {
          let vlans = response.data;
          this.allVlans = vlans.filter(function(el) {
            return el.isActive === true && el.isDeleted === false;
          });
        });
    },
    async createFullInstallTicket() {
      // this.addTicketModal = true
      await Api()
        .post("/ticket", {
          applicationId: this.$route.params.applicationId,
          locationId: this.applicationInfo.locationId,
          currentStatus: "Pending",
          importance: "Average",
          description: "Full fibre & Device Installation",
          ticketCategoryItemId: 17,
          createdById: this.$store.state.user.id,
        })
        .then(() => {
          this.snackbar = true;
          this.text = "Successfully created install ticket!";
          this.fetchTickets();
        });
    },
    async createTicket(type) {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.ticketItem.currentStatus = "Pending";
        this.ticketItem.importance = "Average";

        this.ticketItem.ticketCategoryId = 2;
        if (type == "Passive") {
          this.ticketItem.ticketCategoryItemId = 16;
          this.ticketItem.description = "Passive Fibre Installation";
        } else if (type == "Active") {
          this.ticketItem.ticketCategoryItemId = 15;
          this.ticketItem.description = "ONU Installation";
        } else if (type == "Full") {
          this.ticketItem.ticketCategoryItemId = 17;
          this.ticketItem.description = "Full Fibre & ONU Installation";
        }
        this.ticketCommentLog = [];
        this.filteredCategoryItems = this.ticketCategoryItems.filter(
          (x) => x.ticketCategoryId == this.ticketItem.ticketCategoryId
        );
        this.ticketItem.shareWithIsp = this.applicationInfo.packagesIspId ? true : false;

        this.addTicketModal = true;
      }
    },
    async createNewTicket() {
      this.ticketItem.applicationId = this.$route.params.applicationId;
      this.ticketItem.locationId = this.applicationInfo.locationId;
      if (this.applicationInfo.packagesIsp) {
        this.ticketItem.customerOrganisationId = this.ticketItem.shareWithIsp
          ? this.applicationInfo.packagesIsp.customerOrganisationId
          : null;
      }
      await Api()
        .post("/ticket", this.ticketItem)
        .then((response) => {
          this.fetchTickets();
          if (this.ticketCommentLog.length > 0) {
            for (let i = 0; i < this.ticketCommentLog.length; i++) {
              this.ticketCommentLog[i].ticketId = response.data.id;
            }
            Api()
              .post("/ticketComment", {
                batch: this.ticketCommentLog,
              })
              .then((response) => {});
          }
          if (this.ticketItem.assignedToId) {
            Api().post("/ticketAssignLog", {
              assignedToId: this.ticketItem.assignedToId,
              assignedById: this.$store.state.user.id,
              ticketId: response.data.id,
            });
          }
        });
      this.addTicketModal = false;
      this.ticketItem = {};
      this.ticketCommentLog = [];
    },
    fetchTicketComments(id) {
      Api()
        .get("/ticketComment/byTicket/" + id)
        .then((response) => {
          this.ticketCommentLog = response.data;
        });
    },
    fetchTicketAssignments(id) {
      Api()
        .get("/ticketAssignLog/byTicket/" + id)
        .then((response) => {
          this.ticketAssignedLog = response.data;
        });
    },
    async sendDebitOrder() {
      let contact = this.applicationInfo.billingContactId ? "billing" : "primary";
      if (contact && this.applicationInfo[`${contact}Contact`]) {
        let agreementDate = new Date(this.applicationInfo.createdAt);
        let obj = {
          accountReference: this.applicationInfo.accountReference || "TelecoGlue",
          accountReference: this.applicationInfo.accountReference || "TelecoGlue_" + this.applicationInfo.id,
          mandateRef: this.applicationInfo.id,
          mandateValue: this.applicationInfo.ispRecurringPriceVatInc,
          isIndividual: this.applicationInfo.isOrganisation ? false : true,
          customerTitle: this.applicationInfo[`${contact}Contact`].title || "Mr",
          customerName: this.applicationInfo[`${contact}Contact`].name,
          customerSurname: this.applicationInfo[`${contact}Contact`].surname,
          customerEmail: this.applicationInfo[`${contact}Contact`].emailAddress,
          customerMobile: this.applicationInfo[`${contact}Contact`].mobileNumber,
          customerIdNumber: this.applicationInfo[`${contact}Contact`].idNumber,
          ispAgreementDate:
            agreementDate.getFullYear().toString() +
            (agreementDate.getMonth() < 10
              ? "0" + agreementDate.getMonth().toString()
              : agreementDate.getMonth().toString()) +
            agreementDate.getDate().toString(),
          ispAgreementRef: "Package Terms",
        };
        await Api()
          .post("/netcash/createDebitOrder", obj)
          .then(async (res) => {
            this.applicationInfo.debitOrderStatus = "Sent";
            await Api().put("/applications/" + this.applicationInfo.id, {
              debitOrderStatus: "Sent",
            });
          });
      } else {
        confirm("Please first verify the contacts listed against this order.");
      }
    },

    createServiceAccount() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let serviceAccountIdentifier = Math.floor(Math.random() * 1000000000000) + 1;
        let innerVlan = null;
        let outerVlan = null;
        let uniVlan = null;
        let uniSlan = null;
        if (this.provisionTemplate != null) {
          innerVlan = this.provisionTemplate.innerVlan;
          outerVlan = this.provisionTemplate.outerVlan;
          uniVlan = this.provisionTemplate.uniVlan;
          uniSlan = this.provisionTemplate.uniSlan;
          this.provisionTemplate.downloadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.downloadMbps;
          this.provisionTemplate.uploadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.uploadMbps;
        }
        let deviceId = null;
        let ponMac = null;
        if (this.device !== "" && this.device !== null && typeof this.device !== "undefined") {
          deviceId = this.device.id;
          ponMac = this.device.ponMac;
        }
        let fnoActivationDate = new Date(this.applicationInfo.activationDate);
        let autoProvision = false;
        let autoProvisionType = null;
        let autoConfigure = false;
        let autoConfigureType = null;
        let configurationTemplate = null;
        let radiusConfig = false;
        let radiusConfigSettings = null;
        let deviceBridgeId = this.deviceBridges.find((x) => x.vlanXlate == this.provisionTemplate.outerVlan);
        if (
          !this.provisionTemplate.deviceBridgeId &&
          this.device &&
          this.device != null &&
          this.device.Handle_ID != null &&
          this.device.Handle_ID != 0 &&
          !this.device.isU2000
        ) {
          autoProvision = true;
          // autoConfigure = true
          autoProvisionType = "Zhone";
          fnoActivationDate =
            new Date(this.applicationInfo.activationDate) <= new Date()
              ? new Date()
              : new Date(this.applicationInfo.activationDate);

          this.prepareZhoneTemplate();
          // autoConfigureType = 'Zhone'
        } else if (
          !this.provisionTemplate.deviceBridgeId &&
          this.device &&
          this.device != null &&
          this.device.isU2000
        ) {
          autoProvision = true;
          autoProvisionType = "U2000";
          fnoActivationDate =
            new Date(this.applicationInfo.activationDate) <= new Date()
              ? new Date()
              : new Date(this.applicationInfo.activationDate);
        }
        let wifiArray = [];
        if (this.device.acsDevice && !this.secondaryDevice) {
          autoConfigure = true;
          autoConfigureType = "ACS";
          configurationTemplate = {
            enable: true,
            dnsEnabled: true,
            vlan: this.provisionTemplate.outerVlan
              ? this.provisionTemplate.outerVlan
              : this.provisionTemplate.innerVlan,
            port_1: this.provisionTemplate.port_1,
            port_2: this.provisionTemplate.port_2,
            port_3: this.provisionTemplate.port_3,
            port_4: this.provisionTemplate.port_4,
            connectionType: this.provisionTemplate.connectionType,
            ssid_1: this.provisionTemplate.ssid_1,
            ssid_2: this.provisionTemplate.ssid_2,
            ssid_3: this.provisionTemplate.ssid_3,
            ssid_4: this.provisionTemplate.ssid_4,
            pppoeUsername: this.applicationInfo.pppoeUsername,
            pppoePassword: this.applicationInfo.pppoePassword,
            deviceId: this.device.id,
            acsId: this.device.acsId,
            ponMac: this.device.ponMac,
            serviceType: "INTERNET",
          };
          if (
            this.device.deviceMakeModel.isWifi &&
            this.device.deviceMakeModel.twoGhzWifi &&
            this.device.deviceMakeModel.isWifi &&
            this.device.deviceMakeModel.fiveGhzWifi
          ) {
            wifiArray.push({
              deviceId: this.device.id,
              ssid: this.applicationInfo.ssidUsername + "_2.4Ghz",
              password: this.applicationInfo.ssidPassword,
              enable: true,
              frequency: 2.4,
              vlanId: this.provisionTemplate.outerVlan,
              customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
              organisationId: this.applicationInfo.supplierOrganisationId,
              acsId: this.device.acsId,
            });
            wifiArray.push({
              deviceId: this.device.id,
              ssid: this.applicationInfo.ssidUsername + "_5Ghz",
              password: this.applicationInfo.ssidPassword,
              enable: true,
              frequency: 5,
              vlanId: this.provisionTemplate.outerVlan,
              customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
              organisationId: this.applicationInfo.supplierOrganisationId,
              acsId: this.device.acsId,
            });
          } else if (this.device.deviceMakeModel.isWifi && this.device.deviceMakeModel.twoGhzWifi) {
            wifiArray.push({
              deviceId: this.device.id,
              ssid: this.applicationInfo.ssidUsername + "_2.4Ghz",
              password: this.applicationInfo.ssidPassword,
              enable: true,
              frequency: 2.4,
              vlanId: this.provisionTemplate.outerVlan,
              customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
              organisationId: this.applicationInfo.supplierOrganisationId,
              acsId: this.device.acsId,
            });
          }
        } else if (this.secondaryDevice) {
          autoConfigure = true;
          autoConfigureType = "ACS";
          configurationTemplate = {
            enable: true,
            dnsEnabled: true,
            vlan: this.provisionTemplate.outerVlan
              ? this.provisionTemplate.outerVlan
              : this.provisionTemplate.innerVlan,
            port_1: this.provisionTemplate.port_1,
            port_2: this.provisionTemplate.port_2,
            port_3: this.provisionTemplate.port_3,
            port_4: this.provisionTemplate.port_4,
            connectionType: this.provisionTemplate.connectionType,
            ssid_1: this.provisionTemplate.ssid_1,
            ssid_2: this.provisionTemplate.ssid_2,
            ssid_3: this.provisionTemplate.ssid_3,
            ssid_4: this.provisionTemplate.ssid_4,
            pppoeUsername: this.applicationInfo.pppoeUsername,
            pppoePassword: this.applicationInfo.pppoePassword,
            deviceId: this.secondaryDevice.id,
            acsId: this.secondaryDevice.acsId,
            ponMac: this.secondaryDevice.ponMac,
            serviceType: "INTERNET",
          };
          if (
            this.secondaryDevice.deviceMakeModel.isWifi &&
            this.secondaryDevice.deviceMakeModel.twoGhzWifi &&
            this.secondaryDevice.deviceMakeModel.isWifi &&
            this.secondaryDevice.deviceMakeModel.fiveGhzWifi
          ) {
            wifiArray.push({
              deviceId: this.secondaryDevice.id,
              ssid: this.applicationInfo.ssidUsername
                ? this.applicationInfo.ssidUsername + "_2.4Ghz"
                : this.secondaryDevice.deviceMakeModel.name + "_2.4Ghz",
              password: this.applicationInfo.ssidPassword
                ? this.applicationInfo.ssidPassword
                : this.applicationInfo.primaryContact.mobileNumber,
              enable: true,
              frequency: 2.4,
              vlanId: this.provisionTemplate.outerVlan,
              customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
              organisationId: this.applicationInfo.supplierOrganisationId,
              acsId: this.secondaryDevice.acsId,
            });
            wifiArray.push({
              deviceId: this.secondaryDevice.id,
              ssid: this.applicationInfo.ssidUsername
                ? this.applicationInfo.ssidUsername + "_5Ghz"
                : this.secondaryDevice.deviceMakeModel.name + "_5Ghz",
              password: this.applicationInfo.ssidPassword
                ? this.applicationInfo.ssidPassword
                : this.applicationInfo.primaryContact.mobileNumber,
              enable: true,
              frequency: 5,
              vlanId: this.provisionTemplate.outerVlan,
              customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
              organisationId: this.applicationInfo.supplierOrganisationId,
              acsId: this.secondaryDevice.acsId,
            });
          } else if (this.secondaryDevice.deviceMakeModel.isWifi && this.secondaryDevice.deviceMakeModel.twoGhzWifi) {
            wifiArray.push({
              deviceId: this.secondaryDevice.id,
              ssid: this.applicationInfo.ssidUsername
                ? this.applicationInfo.ssidUsername + "_2.4Ghz"
                : this.secondaryDevice.deviceMakeModel.name + "_2.4Ghz",
              password: this.applicationInfo.ssidPassword
                ? this.applicationInfo.ssidPassword
                : this.applicationInfo.primaryContact.mobileNumber,
              enable: true,
              frequency: 2.4,
              vlanId: this.provisionTemplate.outerVlan,
              customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
              organisationId: this.applicationInfo.supplierOrganisationId,
              acsId: this.secondaryDevice.acsId,
            });
          }
        } else if (this.provisionTemplate.type == "OneDevice") {
          autoConfigure = true;
        }

        if (
          this.applicationInfo.packagesIsp.customerOrganisationId &&
          this.applicationInfo.packagesIsp.customerOrganisation.radiusIntegration
        ) {
          radiusConfig = true;
          radiusConfigSettings = {
            username: this.applicationInfo.pppoeUsername,
            password: this.applicationInfo.pppoePassword,
            speed:
              this.applicationInfo.packagesIsp.packagesFno.speedProfile.downloadMbps +
              "M/" +
              this.applicationInfo.packagesIsp.packagesFno.speedProfile.uploadMbps +
              "M",
          };
        }

        this.applicationInfo.serviceAccountType =
          this.provisionTemplate && this.provisionTemplate.type == "TwoDevice"
            ? "Bridged"
            : this.applicationInfo.serviceAccountType
            ? this.applicationInfo.serviceAccountType
            : "IPoE";
        Api()
          .post("/serviceAccounts", {
            autoConfigure: autoConfigure,
            autoConfigureType: autoConfigureType,
            autoProvision: autoProvision,
            autoProvisionType: autoProvisionType,
            radiusConfig: radiusConfig,
            radiusConfigSettings: radiusConfigSettings,
            configurationTemplate: configurationTemplate,
            deviceBridgeId: this.provisionTemplate.deviceBridgeId,
            wifiProfiles: wifiArray,
            ponMac: ponMac,
            device: this.device,
            serviceAccountIdentifier: serviceAccountIdentifier.toString(),
            authenticationType: this.applicationInfo.serviceAccountType,
            pppoeUsername: this.applicationInfo.pppoeUsername,
            pppoePassword: this.applicationInfo.pppoePassword,
            IPoEActive: true,
            IPoEMacAddress: null,
            fnoActivationDate:
              new Date(this.applicationInfo.activationDate) <= new Date()
                ? new Date()
                : new Date(this.applicationInfo.activationDate),
            fnoDeactivationDate: null,
            initialActivation: null,
            // ispActivationDate: fnoActivationDate,
            ispDeactivationDate: null,
            staticIpv4: null,
            staticIpv6: null,
            deviceId: deviceId,
            locationId: this.applicationInfo.locationId,
            packagesIspId: this.applicationInfo.packagesIspId,
            customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
            supplierOrganisationId: this.applicationInfo.supplierOrganisationId,
            organisationId: this.applicationInfo.organisationId,
            innerVlan: innerVlan,
            outerVlan: outerVlan,
            uniVlan: uniVlan,
            uniSlan: uniSlan,
            isChange: false,
            isDeleted: false,
            isActive: true,
            provisionTemplate: this.provisionTemplate,
            applicationId: this.$route.params.applicationId,
            contactId: this.applicationInfo.primaryContactId,
            device: this.device,
            datatillCustomerId: this.applicationInfo.datatillCustomerId
              ? parseInt(this.applicationInfo.datatillCustomerId)
              : null,
            ispRecurringPriceVatInc: this.applicationInfo.ispRecurringPriceVatInc,
          })
          .then(async (response) => {
            this.applicationInfo.serviceAccountId = response.data.id;

            if (this.applicationInfo.packagesIsp.customerOrganisation.isPrimaryOrganisation) {
              let terms = [
                { name: "month-to-month", value: 1 },
                { name: "6 month", value: 6 },
                { name: "12 month", value: 12 },
                { name: "24 month", value: 24 },
              ];
              let customerAccountObject = {
                recurringInvoiceId: this.applicationInfo.recurringInvoiceId,
                recurringInvoiceReference: this.applicationInfo.recurringInvoiceNumber,
                deviceId: this.applicationInfo.secondaryDeviceId
                  ? this.applicationInfo.secondaryDeviceId
                  : this.device.id,
                reference: response.data.circuitNumber,
                serviceAccountId: this.applicationInfo.serviceAccountId,
                contactId: this.applicationInfo.primaryContactId,
                startDate: fnoActivationDate,
                packagesIspId: this.applicationInfo.packagesIspId,
                supplierOrganisationId: this.applicationInfo.organisationId,
                organisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
                accountingCustomerId: this.applicationInfo.accountingCustomerId,
                radiusAuthentication: this.applicationInfo.serviceAccountType != "IPoE" ? "User" : "Mac",
                username: this.applicationInfo.pppoeUsername,
                password: this.applicationInfo.pppoePassword,
                contractTerm: terms.find((x) => x.name == this.applicationInfo.packagesIsp.term).value,
                isSuspended: false,
                deviceOwnership: "Free to use",
                debitOrderMandateSigned: false,
                status: new Date(fnoActivationDate) <= new Date() ? "Live" : "Pending",
              };
              await Api().post("/customerAccount", customerAccountObject);
            }
            for (let i = 0; i < this.documents.length; i++) {
              Api().put("/upload/" + this.documents[i].id, {
                contactId: this.applicationInfo.primaryContactId,
                serviceAccountId: this.applicationInfo.serviceAccountId,
              });
            }
            if (this.applicationInfo.datatillCustomerId) {
              Api().post("/datatill/createDataAccount", {
                applicationId: this.$route.params.applicationId,
              });
            }

            await this.fetchTickets();
            Api()
              .put("/applications/" + this.$route.params.applicationId, {
                serviceAccountId: response.data.id,
              })
              .then((response) => {
                this.initialize();
              });
          });
        this.text = "Service Account successfully created!";
        this.snackbar = true;
      }
    },
    createLocationContacts(contactId, contactTypeId) {
      Api().post("/locationContact", {
        contactId: contactId,
        locationId: this.applicationInfo.locationId,
        contactTypeId: contactTypeId,
        isActive: true,
        isDeleted: false,
      });
    },
    async approveApplication() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        if (!this.provisionTemplate) {
          this.provisionTemplate = this.applicationInfo.organisationBridgeTemplate;
        }
        let bridge = this.deviceBridges.find((x) => x.vlanXlate == this.provisionTemplate.outerVlan);
        if (bridge) {
          this.provisionTemplate.deviceBridgeId = bridge.id;
        }
        if (this.provisionAccount()) {
          if (this.applicationInfo.packagesIspId !== null && this.applicationInfo.serviceAccountId === null) {
            confirm("Are you sure you would like to approve this application?") && this.approveApplicationProcess();
          } else {
            confirm("Are you sure you would like to approve this application?") && this.approveApplicationProcess();
          }
        } else {
          this.provisionWarningModal = true;
        }
      }
    },
    async approveApplicationProcess() {
      if (this.applicationInfo.primaryContactId) {
        await this.createLocationContacts(this.applicationInfo.primaryContactId, 2);
      }
      if (this.applicationInfo.secondaryContactId !== null) {
        await this.createLocationContacts(this.applicationInfo.secondaryContactId, 5);
      }
      if (this.applicationInfo.billingContactId !== null) {
        await this.createLocationContacts(this.applicationInfo.billingContactId, 8);
      }
      if (this.applicationInfo.packagesIspId !== null && this.applicationInfo.serviceAccountId === null) {
        await this.createServiceAccount();
      }

      Api()
        .put("/applications/" + this.$route.params.applicationId, {
          isApproved: true,
          approvedById: this.$store.state.user.id,
          isResolved: true,
          resolvedById: this.$store.state.user.id,
          resolvedDate: new Date(),
        })
        .then((response) => {
          this.applicationInfo.isApproved = true;
          this.applicationInfo.isResolved = true;
          if(this.applicationInfo.packagesIsp)
            this.notifyIsp();
        });
    },
    rejectApplication() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to reject this application?") &&
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              isResolved: true,
              resolvedById: this.$store.state.user.id,
              resolvedDate: new Date(),
              isDenied: true,
              deniedReason: this.deniedReason,
              deniedById: this.$store.state.user.id,
            })
            .then((response) => {
              this.applicationInfo.isResolved = true;
              this.applicationInfo.isDenied = true;
              this.deniedReasonModal = false;
              if(this.applicationInfo.packagesIsp)
                this.notifyIsp();
            });
      }
    },
    getLinkedContacts() {
      Api()
        .get("/contacts/linked", {
          params: {
            idNumber: this.applicationInfo.primaryContactIdNumber,
            emailAddress: this.applicationInfo.primaryContactEmailAddress,
            mobileNumber: this.applicationInfo.primaryContactMobileNumber,
          },
        })
        .then((response) => {
          this.linkedPrimaryContacts = response.data;
        });
      if (this.applicationInfo.secondaryContactFirstname !== null) {
        Api()
          .get("/contacts/linked", {
            params: {
              idNumber: this.applicationInfo.secondaryContactIdNumber,
              emailAddress: this.applicationInfo.secondaryContactEmailAddress,
              mobileNumber: this.applicationInfo.secondaryContactMobileNumber,
            },
          })
          .then((response) => {
            this.linkedSecondaryContacts = response.data;
          });
      }
      if (this.applicationInfo.billingContactFirstname !== null) {
        Api()
          .get("/contacts/linked", {
            params: {
              idNumber: this.applicationInfo.billingContactIdNumber,
              emailAddress: this.applicationInfo.billingContactEmailAddress,
              mobileNumber: this.applicationInfo.billingContactMobileNumber,
            },
          })
          .then((response) => {
            this.linkedBillingContacts = response.data;
          });
      }
    },
    async getExistingServiceAccounts() {
      this.existingServiceAccounts = [];
      await Api()
        .get("/serviceAccounts/active/byLocation/" + this.applicationInfo.locationId)
        .then((response) => {
          this.existingServiceAccounts = response.data;
          if (!this.existingServiceAccounts.length > 0) {
            this.applicationInfo.isPackageVerified = true;
          }
        });
    },
    async getApplication() {
      await Api()
        .get("/applications/supplier/" + this.$route.params.applicationId)
        .then((response) => {
          this.applicationInfo = response.data;
          this.secondaryDevice = this.applicationInfo.secondaryDevice;
          this.initialAccessBuildDocument = this.applicationInfo.additionalAccessBuildDocument;
          this.initialAccessBuildFee = this.applicationInfo.additionalAccessBuildFeeExclVat;
          this.$router.push({
            query: { search: "", offset: "0", records: "10" },
          });
          if (this.applicationInfo.locationId) {
            this.locationContacts = [];
            if (typeof this.applicationInfo.location.devices !== "undefined") {
              for (let i = 0; i < this.applicationInfo.location.devices.length; i++) {
                if (
                  this.applicationInfo.location.devices[i].deviceMakeModel.deviceType.name == "GPON ONU" &&
                  this.applicationInfo.location.devices[i].isActive
                ) {
                  this.device = this.applicationInfo.location.devices[i];
                }
              }
            }

            if (
              typeof this.applicationInfo.location.locationContacts !== "undefined" &&
              this.applicationInfo.location.locationContacts.length > 0
            ) {
              for (let y = 0; y < this.applicationInfo.location.locationContacts.length; y++) {
                if (
                  this.applicationInfo.location.locationContacts[y].isActive &&
                  !this.applicationInfo.location.locationContacts[y].isDeleted
                ) {
                  this.locationContacts.push(this.applicationInfo.location.locationContacts[y]);
                }
              }
            }
          } else {
            // this.attachLocationModal = true;
          }
          if (this.applicationInfo.coordinates) {
            this.applicationInfo.coordinates = JSON.parse(this.applicationInfo.coordinates);
          }

          this.setActiveTabName("applicationContacts");

          this.getLinkedContacts();
          if (!this.applicationInfo.hasTvOverFibre && this.applicationInfo.packagesIspId === null) {
            this.applicationInfo.isInstallVerified = true;
            this.applicationInfo.isDeviceVerified = true;
          }
        });
      this.pages = new Array(this.locationContacts.length);
      for (let i = 0; i < this.locationContacts.length; ++i) this.pages[i] = 0;
    },
    notifyFno() {
      Api().post("/notifications/application/notifyFno", {
        applicationId: this.$route.params.applicationId,
        organisationId: this.applicationInfo.supplierOrganisationId,
      });
    },
    notifyIsp() {
      Api().post("/notifications/application/notifyIsp", {
        applicationId: this.$route.params.applicationId,
        customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
      });
    },
  },
};
</script>

<style>
.rounded-card {
  border-radius: 30px;
}
.v-stepper__header {
  box-shadow: none;
}
.wrap-text {
  white-space: normal;
}
</style>
